export default {
  en: {
    main_title: "GTAHUB - Support",
    apply: "Apply",
    edit: "Edit",
    description: "Description",
    loading: "Loading...",
    filter: "Filter...",
    copied: "Copied",
    game: "Game",
    web: "Web",
    showOrHideHelp: "To show or hide use",
    or: "or",
    tickets_created: "Tickets created",
    reports_created: "Reports created",
    create_new_ticket: "Create a new ticket",
    create_new_ticket_description: "Choose a category to create a ticket.",
    create_ticket_button: "Create ticket",
    create_report_button: "Create report",
    ticket_created_by: "From:",
    ticket_assigned_to: "Assigned to:",
    ticket_unassigned: "Unassigned",
    duplicate_ticket_title: "You already have one open",
    duplicate_ticket_open: "Open existing ticket",
    take: "Take",
    close: "Close",
    reopen: "Reopen",
    comment: "Comment",
    admin_comment: "Staff",
    staffComments: "Staff Comments",
    edited: "Edited",
    takeAndComment: "Take and comment",
    commentAndClose: "Comment and close",
    commentAndReopen: "Comment and reopen",
    noAssigned: "No one is assigned.",
    assignedTo: "Taken by:",
    category: "Category:",
    open: "Open",
    closed: "Closed",
    ticketName: "ticket",
    reportName: "report",
    hasBeenClosed: "has closed the",
    hasBeenReopened: "has reopened",
    hasBeenEscalated: "has escalated",
    hasBeenTook: "has taken the",
    hasBeenAssignedBy: "has been assigned by",
    hasBeenUnassignedBy: "has been unassigned by",
    hasBeenUntook: "has left the",
    supportName: "Support",
    reportsName: "Reports",
    openeds: "Open",
    closeds: "Closed",
    mine: "Assigned to me",
    jury_duty: "Jury Duty",
    attachments: "Images and/or videos",
    noAttachments: "No videos or images attached.",
    attachmentsHelp:
      "We recommend using https://gofile.io/ to upload your evidence. Enter the URLs of any images or videos you have. If you have more than one, click the 'add' button.",
    attachmentsMax: "Maximum {max} items",
    attachmentLinkInvalid: "Link not allowed: use {hosts}",
    attachmentLinkInvalidMore: "Link not allowed: use {hosts} and {n} more",
    warning: "Warning",
    hubHour: "Server Time (HUB):",
    cancel: "Cancel",
    groups: "Groups",
    stars: "Stars",
    roles: "Roles",
    users: "Users",
    select_all: "Select all",
    logout: "Log out",
    hasBeenRequestedMoreResponses: "requested more interventions from staff.",
    unassigned: "Unassigned",
    supportAlert:
      "We will never ask for private or sensitive information through any means. If you receive such requests, be aware they might be scams. The security of your data is our top priority. Remember that the official launcher can only be downloaded from our website. Avoid downloading it from unauthorized sites or those sent by third parties, as they could contain viruses or other malicious elements.",
    reviewTitle: "Give feedback",
    review_one_star: "Very bad, did not solve my problem",
    review_two_stars: "Bad, did not solve my problem",
    review_three_stars: "Average, but my problem was resolved",
    review_four_stars: "Good, solved my problem",
    review_five_stars: "Excellent, solved my problem",
    write_your_review: "Write your feedback...",
    send_review: "Send feedback",
    review_sended: "Feedback sent, thank you.",
    myReviews: "My rating",
    statistics: "Statistics",
    responseTime: "Response time",
    precannedAnswers: "Precanned answers",
    assigneds: "Assigneds",
    support_name: "GTAHub Support",
    error: "Error",
    supportCenter: "Support Center",
    needHelpStartHere: "Need help? Start here.",
    iNeedHelp: "I need help",
    ctaGetSupport: "Request support",
    iWantToReportSomeone: "I want to report someone",
    yourTickets: "Your tickets",
    hideWelcomeBanner: "Hide header",
    showWelcomeBanner: "Show welcome header",
    welcome: "Welcome",
    to: "to",
    wereHereForYou: "Open a ticket or follow your existing requests.",
    simpleTicket: {
      title: "What do you need?",
      placeholder: "Tell us what you need help with, in at least 20 characters",
      charsLeft: "{n} more characters to go",
      searchPlaceholder: "Search categories",
      noCategories: "No categories match your search",
      chosen: "Category: {name}",
      loading: "Looking for categories...",
      reportInstead: "Report a player instead",
      decidedAs: "We are handling this as: {name}",
      decidedFallback: "We will send this to: {name}",
      notThis: "Not this",
      pickCategory: "Choose the category",
      thinking: "Finding the best category…",
    },
    simpleReport: {
      title: "Report a player",
      accusedHelp: "FirstName_LastName or #HASH",
      whatHappened: "What happened?",
      detected: "This looks like a report against a player.",
      notAReport: "It's not a report",
      descriptionPlaceholder: "Tell us what the player did, where and how, in at least 20 characters",
      charsLeft: "{n} more characters needed",
      categoryLoading: "Looking for categories...",
      searchPlaceholder: "Search report categories",
      noCategories: "No categories match your search.",
      evidence: "Evidence",
      evidenceOptional: "Evidence (optional)",
      evidenceHelp: "Paste the links to your images or videos (for example from https://gofile.io/).",
      when: "When",
      now: "Just now",
      changeDate: "Change date",
      useNow: "Use the current time",
      moreDetails: "More details",
      lessDetails: "Fewer details",
      moreDetailsHint: "All optional.",
      juryInfo: "Your report may be resolved by a community jury",
      consent: "I have read the rules and I accept that making a false or bad-faith report may lead to sanctions",
      consentRead: "Read the rules",
      submit: "Send report",
      errorCategory: "Choose a category from the list",
      errorDescription: "Describe what happened in at least {min} characters",
      errorEvidence: "Add at least one link to your evidence",
      errorConsent: "You must accept the rules to send the report",
      errorNoGroup: "Report categories are not available right now",
      errorGeneric: "The report could not be sent. Please try again.",
      decidedAs: "We are handling this as: {name}",
      decidedFallback: "We will send this to: {name}",
      notThis: "Not this",
      pickCategory: "Choose the category",
      chosen: "Category: {name}",
    },
    categorySelection: {
      selectGroup: "What do you need help with?",
      selectCategory: "Select a category",
      back: "Back",
      close: "Close",
      describeTitle: "Describe your problem",
      describePlaceholder: "Tell us what happened in a few words, e.g. \"my car disappeared from the garage\"",
      describeHint: "We will suggest the right category as you type.",
      suggestionsTitle: "Suggested categories",
      suggestionsLoading: "Looking for categories...",
      noSuggestions: "No suggestions yet. Keep describing your problem or choose the category manually.",
      chooseManually: "Choose the category manually",
      describeInstead: "Describe my problem instead",
      searchPlaceholder: "Search categories...",
      noSearchResults: "No categories match your search."
    },
    categorySuggestion: {
      badge: "Suggested category",
      move: "Move",
      moveTitle: "Move this ticket to the suggested category",
      moveFailed: "Could not move the ticket."
    },
    actions: "Actions",
    send: "Send",
    takenBy: "Taken by",

    // reports
    create_new_report_description: "Choose a category to create a report.",
    oldest_comment: "Oldest comment",
    newest: "Most recent ticket",
    oldest: "Oldest ticket",
    staff: "Staff priority",
    staff_latest: "Staff priority (latest)",

    title: {
      admin_panel: "Administration Panel",
      suport_panel: "Support",
    },

    you_have: "You have",

    ticket: {
      title: "Title",
      category: "Category",
      status: "Status",
      responder: "Responder",
      date: "Date",
      assign: "Assign",
      escalate: "Escalate",
      escalateTo: "Change to group / category",
      escalateNone: "No other groups available",
      create_new: "Create a new ticket",
      is_closed: "This ticket is closed",
      take_review: "Please review again.",
      write_message: "Writing...",
      you_took_review: "You reviewed this response",
      review_of_your_answer: "Review of your response",
      title_of_ticket: "Ticket title",
      content_of_ticket: "Ticket content",
      your_opened_tickets: "Your open tickets",
      opened_tickets: "Open tickets",
      click_on_ticket: "Click on the ticket to open it",
      send: "Send",
      no_tickets:
        "There are no tickets. Try changing filters or create one if you have a problem.",
      take: "Take ticket",
      description: "Description",
      reporter: "Reporter",
      commentAndClose: "Comment and close",
      reported_user: "Reported User",
      created: "Created",
      lastReply: "Last reply",
      ago: "ago",
      unread: "unread",
      unread_one: "unread",
      noAnswer: "No answer",
      takenBy: "Taken by",
      createdBy: "Created by",
      attachment: "attachment",
      attachments: "attachments",
      openAllInTabs: "Open all in tabs",
      staffPriority: "Staff Priority",
      andNMore: "and {n} more",
      assignNone: "No assignees available",
      closed: "Ticket closed",
      comments_count: "Comments",
      context: "Ticket Context",
      created_at: "Created",
      details: "Ticket Details",
      history: "History",
      id: "Ticket ID",
      id_copied: "Ticket ID copied to clipboard",
      last_comment: "Last Comment",
      last_updated: "Last Updated",
      reopened: "Ticket reopened",
      selectTicket: "Select a ticket to view details",
      taken: "Ticket taken",
      unassigned: "Ticket unassigned",
      unknown_type: "Unknown ticket type",
      view: {
        label: "View",
        user: "User view",
        workspace: "Workspace",
      }
    },

    filters: "Filters",
    copyLink: "Copy link",
    takeTicket: "Take ticket",
    takeToReply: "Take the ticket to reply.",
    editingInComposer: "Editing in composer. Use the main send button.",
    sendStaffOnly: "Send (staff only)",

    assistant: {
      hide: "Hide",
      title: "Staff Assistant",
      close: "Close",
      conversations: "Conversations",
      newChat: "New",
      placeholder: "Ask for summary, next steps, results..."
    },

    write_your_message: "Write your message...",
    latest_comment: "Latest comment",
    delete: "Delete",
    deleteCommentTitle: "Delete comment",
    deleteCommentText: "Are you sure you want to delete this comment?",

    socketDisconnected:
      "You have been disconnected from the server. Please check your internet connection and refresh the page.",

    requestTimeout: "Request timed out. Please check your connection and try again.",
    dashboardStats: {
      tickets: { total: "Tickets", unassigned: "Unassigned tickets" },
      reports: {
        total: "Reports",
        unassigned: "Unassigned reports",
        openUnassigned: "Open reports without assignee",
        olderThan30d: "Open reports older than 30 days",
        medianFirstResponseHours7d: "Reports: median first response (7d)",
      },
      support: { medianFirstResponseHours7d: "Support: median first response (7d)" },
      hoursUnit: "h",
      noData: "No data",
    },

    authCallbackLoading: "Signing you in...",
    authCallbackFailed: "We couldn't sign you in. Redirecting you to the login page...",
    authCallbackGiveUp: "We couldn't sign you in. Please reload the page to try again.",
    authCallbackStateMismatch: "This login link is not valid for this session.",

    socketConnectionLost: "Connection lost. Please refresh the page.",
    socketSessionExpired: "Session may have expired. Please refresh the page to sign in again.",
    socketDisconnectedBanner: "Disconnected. Ticket list will refresh every minute until reconnected.",
    socketReconnecting: "Reconnecting… this report will update when the connection is back.",

    support: {
      opened_tickets: "Open tickets",
      your_assignments: "Your assignments",
      no_assigned_tickets: "You have no assigned tickets",
      no_tickets: "There are no tickets currently awaiting a response",
      responder: "Assigned to",
    },

    report: {
      accused: "Accused",
      reporter: "Reporter",
      accused_help: "FirstName_LastName or #HASH",
      partners: "Accomplices",
      date_of_event: "Date and time of the event",
      date_of_event_info: "Select according to your local time, it will automatically convert to HUB time of the server.",
      date_of_event_hub: "Date and time of the event (HUB)",
      no_reports: "You have not created any reports nor have you been reported. Nothing to show.",
      now: "Now",
      addPartner: "Add",
      removePartner: "Remove",
      partner: "Accomplice",
      reason: "Reason (broken rules)",
      broken_rules: "Broken rules",
      description: "Description of the events",
      take: "Take report",
      secondaryRules: "Secondary rules",
      secondary_rules: "Secondary rules",
      secondaryRulesInfo: "It is not necessary to add rules in this menu. Here you can select a rule that is not in the above menu, keep in mind that you will get a sanction if you add rules that have not been broken in the report.",
      in_fraganti_label: "Happening right now",
      in_fraganti_warning: "Only activate this option if the report is really happening right now. Reports with this option that are false can lead to sanctions.",
      invalid: "Invalid",
      valid: "Valid",
      resolutionTitle: "Report resolution.",
      resolutionInfo: "Select if the report was valid (the reporter was right and those involved will receive their sanctions) or invalid.",
      request_more_responses: "Require more interventions",
      // Enhanced reporting fields
      type: "Report Type",
      type_normal: "Normal Report",
      type_normal_desc: "Staff will review and make the final decision",
      type_jury: "Jury-Based Report",
      type_jury_desc: "Community jury will vote on validity before staff review",
      suggested_penalties: "Suggested Penalties",
      suggested_penalties_help: "Select the penalty blocks you believe should be applied. These are suggestions for the final review.",
      accused_required: "You must specify the accused player",
      description_required: "You must provide a description of the events",

      // Live notifications
      juryAssigned: "Jury of {count} members assigned",
      juryValid: "valid",
      juryInvalid: "invalid",
      juryVotingComplete: "Jury voting complete: report {result}",
      juryVotingExpired: "Jury voting deadline expired",
      staffAssigned: "Staff member {name} assigned",
      deadlineWarning: "Warning: {type} deadline in {hours} hours",
      deadline: {
        response: "Response",
        conciliation: "Conciliation",
        jury: "Jury voting",
        postJury: "Post-jury choice",
        staffVoting: "Staff voting",
      },
      
      // Report Status
      close: "Close Report",
      closed: "Report has been closed",
      accepted: "Report Accepted",
      accepted_by_user: "Accepted by Reported User",
      acceptedByReported: "Report has been accepted by the reported user",
      agreement_reached: "Agreement Reached",
      agreementReached: "Agreement reached",
      parties_agreed: "Parties Reached Agreement",
      accept_staff_review_note: "The reported user accepted the report in good faith. Staff can now review and apply final penalty blocks (with penalty reduction applied).",
      agreement_staff_review_note: "Both parties reached an agreement during conciliation. Staff can now review and apply the agreed penalty blocks or adjust them as needed.",
      resolve_type_accept_locked: "Resolve type is set to Accept Guilt as the reported user accepted the report",
      resolve_type_agreement_locked: "Resolve type is set to Agreement as both parties reached an agreement",
      agreed_penalties: "Agreed Penalties",
      final_penalties: "Final Penalties",
      penalty_reduction: "Penalty Reduction",
      related_reports: "Related Reports",
      conciliationExpired: "Conciliation period has expired",
      disputedStartConciliation: "Report has been disputed - conciliation started",
      responseDeadlineExpired: "Response deadline expired - auto-disputed",
      newTradeProposal: "New penalty trade proposal",
      counterProposalReceived: "Counter-proposal received",
      tradeAccepted: "Trade proposal accepted. Agreement reached.",
      tradeRejected: "Trade proposal rejected",
      statusUpdated: "Report status updated",

      status: "Report Status",
      normal: "Normal",
      jury_based: "Jury-Based",

      // Deadlines
      response_deadline: "Response Deadline",
      conciliation_deadline: "Conciliation Deadline",
      jury_voting_deadline: "Jury Voting Deadline",
      post_jury_choice_deadline: "Party Choice Deadline",
      staff_voting_deadline: "Staff Voting Deadline",
      deadline_expired: "Expired",
      days: "days",
      minutes: "minutes",

      // Accept/Dispute
      your_response: "Your Response",
      response_instructions: "You have been reported. Please review the report details and choose how to respond. You can either accept the report and receive a reduced penalty, or dispute it and enter the conciliation phase.",
      accept_report: "Accept Report",
      accept_description: "By accepting, you acknowledge the violation. You will receive a penalty reduction as an incentive for accepting responsibility.",
      penalty_reduction_info: "You will receive a {percent}% reduction on the penalty.",
      accept: "Accept",
      dispute_report: "Dispute Report",
      dispute_description: "By disputing, you will enter a conciliation phase where you can negotiate with the reporter. If no agreement is reached, the report may go to jury review or staff review.",
      dispute: "Dispute",
      already_accepted: "You have already accepted this report. The penalty reduction has been applied.",
      already_disputed: "You have disputed this report. Please check the conciliation phase for updates.",
      confirm_accept_title: "Confirm Acceptance",
      confirm_accept_text: "Are you sure you want to accept this report? This action cannot be undone.",
      accepted_success: "Report accepted successfully. Penalty reduction has been applied.",
      error_accepting: "An error occurred while accepting the report.",
      confirm_dispute_title: "Confirm Dispute",
      confirm_dispute_text: "Are you sure you want to dispute this report? This will start the conciliation phase.",
      disputed_success: "Report disputed successfully.",
      conciliation_started: "The conciliation phase has begun. You can now negotiate with the reporter.",
      error_disputing: "An error occurred while disputing the report.",

      // Conciliation
      conciliation: "Conciliation",
      conciliation_instructions: "Conciliation: negotiate the penalty with the other party by exchanging proposals of penalty blocks. The ticket chat is closed in this phase, so everything happens through proposals: make one, then the other party accepts, rejects or counters it. An agreement goes to staff for the final decision.",
      messages: "Messages",
      no_messages: "No messages yet. Start the conversation to negotiate.",
      type_message: "Type your message...",
      send_message: "Send Message",
      error_sending_message: "An error occurred while sending the message.",

      // Spotlight coach (party + jury onboarding)
      coach: {
        step_of: "Step {current} of {total}",
        skip: "Skip",
        continue: "Continue",
        finish: "Got it",
        replay: "How Overwatch works",
        party: {
          status_title: "Report progress",
          status_body: "This bar shows where the report is in the Overwatch flow: response, conciliation, jury or staff review.",
          deadlines_title: "Deadlines",
          deadlines_body: "Each phase has a timer. Act before it expires or the system may move the report forward automatically.",
          accept_dispute_title: "Your response",
          accept_dispute_body: "If you were reported, accept for a reduced penalty or dispute to open conciliation with the other party.",
          conciliation_title: "Conciliation",
          conciliation_body: "Negotiate penalty blocks with the other party. An agreement still goes to staff for a final decision.",
          chat_title: "Chat",
          chat_body: "Use the ticket chat to share evidence. It is closed during conciliation (negotiate with proposals instead) and limited to a few messages during the jury phase.",
        },
        jury: {
          instructions_title: "Jury review",
          instructions_body: "Read the case carefully. You are reviewing whether the report is valid based on the evidence, not punishing anyone yourself.",
          vote_title: "Cast your vote",
          vote_body: "Vote Valid if rules were broken, or Invalid if the report lacks merit. You can only vote once.",
          chat_title: "No chat for jurors",
          chat_body: "Jurors cannot write in the case chat and cannot be contacted by the parties. Base your vote only on the evidence shown.",
        },
      },

      // Staff Review
      review: "Staff Review",
      details: "Report Details",
      close_report: "Close Report",
      resolve_type: "Resolution Type",
      resolve: {
        unresolved: "Unresolved",
        agreement: "Agreement",
        accept_guilt: "Accepted Guilt",
        valid: "Valid (Report Upheld)",
        invalid: "Invalid (Report Dismissed)"
      },
      error_closing: "An error occurred while closing the report.",
      post_jury: {
        title: "Jury verdict: your choice",
        hint_guilty: "The jury found the report valid (guilty). You may accept the sanction or request a staff review.",
        hint_innocent: "The jury dismissed your report because they believe the subject is innocent. Accept their decision to close the case, or escalate to staff if you disagree.",
        accept_sanction: "Accept my sanction (100%)",
        accept_innocent: "Accept jury decision and close case",
        appeal_staff: "Escalate to staff",
        hint_no_verdict: "The jury could not reach a verdict (too few votes or a tie). Without a verdict there is no sanction; either party may escalate the case to staff.",
        accept_no_verdict: "Drop the report with no sanction",
        appeal_confirm_title: "Escalate to staff?",
        appeal_confirm_guilty: "Staff will vote on your case. If they confirm the verdict, your penalty is multiplied by {m}. If they reject it, there is no sanction. This cannot be undone.",
        appeal_confirm_innocent: "Staff will vote on the case. If they find the report valid, the accused's penalty is multiplied by {m}. This cannot be undone.",
        appeal_confirm_no_verdict: "Staff will vote on the case. If they find the report valid, the normal penalty applies. This cannot be undone.",
        accept_confirm_title: "Accept the jury's decision?",
        accept_confirm_guilty: "Staff will confirm the verdict and apply the full penalty. You will not be able to escalate afterwards.",
        accept_confirm_innocent: "Once staff confirm it, the case closes with no sanction. You will not be able to escalate afterwards.",
        accept_confirm_no_verdict: "Once staff confirm it, the report is dropped with no sanction. You will not be able to escalate afterwards."
      },
      staff_vote: {
        title: "Staff vote",
        progress: "Accept {accept} · Reject {reject} · Need {needed} of {pool}",
        progress_majority: "Accept {accept} · Reject {reject} · Majority of the votes cast, at least {needed} votes",
        assigned: "Assigned reviewers",
        accept: "Accept / Convict",
        reject: "Reject / Invalid",
        already_voted: "You voted: {vote}",
        threshold_reached: "Vote threshold reached. Finalize penalties below.",
        mock_all_accept: "DEV: Mock staff → Accept",
        mock_all_reject: "DEV: Mock staff → Reject",
        mock_votes_title: "Mock staff votes? (DEV)",
        mock_votes_success: "Mocked {count} remaining staff vote(s).",
        mock_votes_error: "Failed to mock staff votes.",
        vote_word_accept: "accept",
        vote_word_reject: "reject",
        confirm_title: "Cast your vote?",
        confirm_accept_text: "Your vote cannot be changed. If the majority accepts, the penalty is applied with quantities ×{m}.",
        confirm_reject_text: "Your vote cannot be changed. If the majority rejects, no penalty is applied."
      },
      settlement_staff_takeover: "Players reached an agreement. You may add, remove, or edit penalty blocks. Your decision is final.",
      settlement_original_agreement: "Original player agreement",
      settlement_edit_hint: "Edit the final blocks below. Closing applies your selection.",
      review_load_failed: "The report data could not be loaded.",
      // ENG-1758: unified progress, next-step, outcome and consequence copy
      progress: {
        title: "Progress",
        step: {
          filed: "Filed",
          response: "Response",
          conciliation: "Conciliation",
          jury: "Jury",
          verdict: "Verdict",
          staff: "Staff",
          closed: "Closed"
        },
        state: {
          done: "Done",
          current: "Now",
          future: "Next",
          skipped: "Skipped"
        }
      },
      countdown: {
        expired: "time is up, processing",
        in_minutes: "in {m} min",
        in_hours_minutes: "in {h} h {m} min",
        in_days_hours: "in {d} d {h} h",
        until: "until {date}"
      },
      deadline_kind: {
        response: "Accused's answer",
        conciliation: "End of negotiation",
        proposal: "Answer to the current proposal",
        jurySelection: "Jury formation",
        juryVoting: "Jury vote",
        postJury: "Accept or escalate the verdict",
        staffVoting: "Staff vote",
        agreementClose: "Automatic close with the agreement"
      },
      deadline_owner: {
        accused: "Waiting for: the accused",
        parties: "Waiting for: both parties",
        reporter: "Waiting for: the reporter",
        jurors: "Waiting for: the jurors",
        staff: "Waiting for: staff",
        system: "Waiting for: jurors to sign up",
        proposalResponder: "Waiting for: the party who received the proposal",
        you: "Waiting for: you"
      },
      next: {
        title: "What happens now",
        can_label: "What you can do",
        deadline_label: "Deadline",
        no_deadline: "No automatic deadline in this phase.",
        created: {
          any: { now: "The report was filed and is being set up.", can: "Nothing to do yet. You will be notified when the next phase starts." }
        },
        pending_response: {
          accused: { now: "You were reported. You must accept or dispute the report before the deadline.", can: "Accept for a reduced penalty, or dispute to negotiate with the reporter. If you do nothing, the report is disputed automatically." },
          reporter: { now: "Waiting for the accused to accept or dispute the report.", can: "Nothing to do now. If they do not answer in time, the report is disputed automatically and goes to conciliation." },
          staff: { now: "Waiting for the accused's answer.", can: "No action needed yet." },
          any: { now: "Waiting for the accused's answer.", can: "Nothing to do now." }
        },
        accepted: {
          accused: { now: "You accepted the report. Staff will apply the reduced penalty and close it.", can: "Nothing else to do. The outcome will appear here." },
          reporter: { now: "The accused accepted the report. Staff will apply the penalty and close it.", can: "Nothing to do. The outcome will appear here." },
          staff: { now: "The accused accepted the report. The reduction is already applied to the proposed blocks.", can: "Review the final blocks and close the report." },
          any: { now: "The accused accepted the report. Staff will close it.", can: "Nothing to do now." }
        },
        disputed: {
          any: { now: "The report was disputed and conciliation is starting.", can: "Wait a moment: the negotiation panel opens by itself." }
        },
        conciliation: {
          reporter: { now: "Conciliation: both parties negotiate the penalty by exchanging proposals of penalty blocks. The chat is closed during this phase.", can: "Make, accept, reject or counter a proposal in the panel below. Each proposal has its own answer timer. Without an agreement by the deadline, the case goes to a jury (jury reports) or to staff." },
          accused: { now: "Conciliation: both parties negotiate the penalty by exchanging proposals of penalty blocks. The chat is closed during this phase.", can: "Make, accept, reject or counter a proposal in the panel below. Each proposal has its own answer timer. Without an agreement by the deadline, the case goes to a jury (jury reports) or to staff." },
          staff: { now: "The parties are negotiating the penalty.", can: "No action needed. The agreement, if any, comes to you for review." },
          any: { now: "The parties are negotiating the penalty.", can: "Nothing to do now." }
        },
        agreement_reached: {
          reporter: { now: "You reached an agreement. Staff will confirm it and close the report. If staff do not act, it closes automatically with the agreed penalty at the deadline.", can: "Nothing else to do." },
          accused: { now: "You reached an agreement. Staff will confirm it and close the report. If staff do not act, it closes automatically with the agreed penalty at the deadline.", can: "Nothing else to do." },
          staff: { now: "The parties reached an agreement. If nobody closes it, it closes automatically with the agreed penalty at the deadline.", can: "Confirm or adjust the agreed blocks and close the report." },
          any: { now: "The parties reached an agreement. Staff will close the report.", can: "Nothing to do now." }
        },
        conciliation_expired: {
          any: { now: "Conciliation ended without an agreement. The case is moving to the next phase.", can: "Nothing to do. This screen updates by itself." }
        },
        jury_phase: {
          juror: { now: "You joined this jury. Voting starts as soon as every seat is filled.", can: "Read the case while you wait." },
          staff: { now: "Players are being recruited as jurors.", can: "If selection is stuck, retry it from the notice above. If no jury is formed in time, the case comes to staff." },
          any: { now: "A jury of players is being formed to review the case.", can: "Nothing to do. If no jury is formed in time, the case goes to staff." }
        },
        jury_voting: {
          juror: { now: "Decide whether the report is valid based only on the evidence.", can: "Cast your vote below before the deadline. Your vote is anonymous and cannot be changed." },
          staff: { now: "The jury is voting.", can: "No action needed. You review the case after the verdict if a party escalates it." },
          any: { now: "An anonymous jury of players is voting on whether the report is valid.", can: "Nothing to do. Jurors cannot be contacted." }
        },
        jury_valid: {
          chooser: { now: "The jury found the report valid.", can: "Accept the sanction (full penalty) or escalate to staff (the penalty is multiplied by 1.5 if staff confirm it). If you do not choose before the deadline, the sanction is accepted automatically." },
          waiting: { now: "The jury found the report valid. The accused can accept the sanction or escalate to staff.", can: "Nothing to do. If they do not choose in time, the sanction is accepted automatically." },
          juror: { now: "Voting finished: the report was found valid.", can: "Nothing else to do. Thanks for taking part." },
          staff: { now: "Jury verdict: valid. Waiting for the accused's choice.", can: "No action needed yet." },
          any: { now: "The jury found the report valid.", can: "Nothing to do now." }
        },
        jury_invalid: {
          chooser: { now: "The jury dismissed the report.", can: "Accept the decision (the case closes with no sanction) or escalate to staff. If you do not choose before the deadline, the decision is accepted automatically." },
          waiting: { now: "The jury dismissed the report. The reporter can accept the decision or escalate to staff.", can: "Nothing to do. If they do not choose in time, the case closes with no sanction." },
          juror: { now: "Voting finished: the report was dismissed.", can: "Nothing else to do. Thanks for taking part." },
          staff: { now: "Jury verdict: invalid. Waiting for the reporter's choice.", can: "No action needed yet." },
          any: { now: "The jury dismissed the report.", can: "Nothing to do now." }
        },
        jury_no_verdict: {
          chooser: { now: "The jury could not reach a verdict (a tie or too few votes). Without a verdict there is no sanction.", can: "Either party may escalate the case to staff before the deadline. If nobody does, the case closes with no sanction." },
          waiting: { now: "The jury could not reach a verdict.", can: "Nothing to do now." },
          juror: { now: "Voting finished without a verdict.", can: "Nothing else to do. Thanks for taking part." },
          staff: { now: "The jury reached no verdict. Waiting for the parties to escalate or let it close.", can: "No action needed yet." },
          any: { now: "The jury could not reach a verdict.", can: "Nothing to do now." }
        },
        staff_review: {
          staff: { now: "This report needs a staff decision.", can: "Choose the final penalty blocks and the resolution, then close the report." },
          any: { now: "Staff are reviewing the case and will decide the final penalty.", can: "Nothing to do. Staff review has no automatic deadline; you will be notified of the outcome." }
        },
        staff_voting: {
          staff: { now: "Several staff members vote on this case. The majority of the votes cast decides.", can: "Vote Accept or Reject below before the deadline." },
          any: { now: "Several staff members are voting on the case. The majority of the votes cast decides.", can: "Nothing to do. You will be notified of the outcome." }
        },
        closed: {
          any: { now: "The report is closed.", can: "See the outcome below." }
        }
      },
      outcome: {
        title: "Outcome",
        resolution: "Resolution",
        penalty: "Penalty applied",
        no_penalty: "No penalty was applied.",
        penalty_hidden: "The penalty details are only visible to the parties and staff.",
        multiplier: "Penalty scale ×{m}",
        score: "Your reputation change",
        score_none: "No reputation change for you.",
        no_verdict: "The jury reached no verdict."
      },
      accept_consequence: "Accepting is final: you admit the violation, the penalty is reduced by {percent}% and staff apply it. You cannot dispute afterwards.",
      accept_no_penalty_proposed: "No penalty was proposed in this report: staff will set it. Your {percent}% reduction still applies.",
      proposed_penalty_by_staff: "The penalty will be set by staff.",
      dispute_consequence_jury: "Disputing opens a negotiation with the reporter. Without an agreement, the case goes to a jury of players.",
      dispute_consequence_staff: "Disputing opens a negotiation with the reporter. Without an agreement, the case goes to staff.",
      close_confirm_title: "Close the report?",
      close_confirm_text: "Resolution: {resolution}. {penalty} This is final: penalties are applied and the parties are notified.",
      close_preview_none: "No penalty will be applied.",
      close_preview_blocks: "{count} penalty block(s) will be applied.",
      close_preview_blocks_scaled: "{count} penalty block(s) will be applied, quantities ×{m}.",
      // Protected-user approval gate
      pendingApproval: "Awaiting staff approval",
      protectedTargetExplanation: "This report targets a protected user and must be reviewed by staff before the accused is notified.",
      approve: "Approve and notify",
      reject: "Reject",
      rejected: "Rejected by staff",
      rejectReason: "Reason (optional)",
      pendingApprovalFilter: "Pending approval",
      rejectedFilter: "Rejected"
    },

    // Report Status (flat keys for $t calls)
    reportStatus: {
      created: "Created",
      pending_response: "Pending Response",
      accepted: "Accepted",
      disputed: "Disputed",
      conciliation: "In Conciliation",
      agreement_reached: "Agreement Reached",
      conciliation_expired: "Conciliation Expired",
      jury_phase: "Jury Phase",
      jury_voting: "Jury Voting",
      jury_valid: "Jury: Valid",
      jury_invalid: "Jury: Invalid",
      staff_review: "Staff Review",
      jury_no_verdict: "Jury: No verdict",
      staff_voting: "Staff Voting",
      closed: "Closed"
    },

    // Report Actions
    reportActions: {
      accept: "Accept Report",
      accept_confirm: "Are you sure you want to accept this report? You will receive a penalty reduction.",
      accept_info: "By accepting, you acknowledge the violation and receive a {reduction}% penalty reduction.",
      dispute: "Dispute Report",
      dispute_confirm: "Are you sure you want to dispute this report? This will start the conciliation phase.",
      dispute_info: "Disputing will start a {hours}-hour conciliation period where you can negotiate with the reporter.",
      respond: "Respond",
      view_details: "View Details",
      close_report: "Close Report",
      apply_penalties: "Apply Penalties"
    },

    // Conciliation
    conciliation: {
      title: "Conciliation",
      description: "Negotiate with the other party to reach an agreement.",
      time_remaining: "Time Remaining",
      hours: "hours",
      minutes: "minutes",
      send_message: "Send Message",
      message_placeholder: "Type your message...",
      no_messages: "No messages yet. Start the conversation.",
      chat_blocked: "Chat is disabled during conciliation phase.",
      reject_confirm_jury: "Rejecting ends the negotiation right away: the case goes to a jury of players. This cannot be undone.",
      reject_confirm_staff: "Rejecting ends the negotiation right away: the case goes to staff review. This cannot be undone.",
      reject_confirm_normal: "The proposal is rejected. The negotiation continues until the conciliation deadline; without an agreement, the case goes to staff.",
      proposal_timer_you: "You must answer this proposal",
      proposal_timer_them: "The other party must answer this proposal",
      proposal_timer_hint: "A proposal that is not answered in time is rejected automatically.",

      trading: {
        title: "Penalty Block Trading",
        current_proposal: "Current Proposal",
        original_blocks: "Original Blocks",
        proposed_blocks: "Proposed Blocks",
        propose_new: "Propose New Trade",
        accept_proposal: "Accept Proposal",
        reject_proposal: "Reject Proposal",
        counter_proposal: "Counter-Propose",
        no_proposals: "No active proposals. You can propose a penalty trade.",
        proposal_accepted: "Proposal Accepted",
        proposal_rejected: "Proposal Rejected",
        waiting_response: "Waiting for the other party to respond...",
        your_turn: "Your turn to respond",
        their_turn: "Waiting for other party",
        // NEW: Additional turn-based trading keys
        history: "Trade History",
        propose_help: "Select the penalty blocks you want to propose. The other party will need to accept, reject, or counter your proposal.",
        counter_help: "Select different penalty blocks as your counter-proposal. The other party will then respond to your new offer.",
        message_optional: "Message (optional)",
        message_placeholder: "Explain your proposal...",
        submit_proposal: "Submit Proposal",
        submit_counter: "Submit Counter-Proposal",
        status_pending: "Pending",
        status_accepted: "Accepted",
        status_rejected: "Rejected",
        status_countered: "Countered",
        status_expired: "Expired",
        // Error messages
        error_not_your_turn: "It's not your turn to respond",
        error_must_respond: "You must accept, reject, or counter the current proposal first",
        error_waiting: "Waiting for the other party to respond to your proposal",
        original_proposal: "Original Proposal",
        original_proposal_description: "This is the initial penalty proposal from the reporter. You can propose a counter-proposal below.",
        propose_counter: "Propose a counter-proposal",
        proposed_by: "Proposed by",
      },

      agreement: {
        title: "Agreement Reached",
        description: "Both parties have agreed on the following penalties:",
        agreed_blocks: "Agreed Penalty Blocks",
        proceed_to_review: "This will now go to staff for final review."
      },

      expired: {
        title: "Conciliation Expired",
        description: "The conciliation period has ended without an agreement.",
        next_step_jury: "This report will now go to jury voting.",
        next_step_staff: "This report will now go to staff review."
      }
    },

    // Jury System
    jury: {
      title: "Jury Review",
      enter_as_jury: "Enter as Jury",
      no_available_tickets: "No available jury tickets found at this time.",
      available_list_title: "Open jury cases",
      available_list_empty: "There are no open jury cases right now.",
      available_list_seats: "{current} / {max} jurors",
      available_list_join: "Join",
      available_list_close: "Close",
      available_list_phase_recruiting: "Recruiting jurors",
      available_list_phase_voting: "Voting in progress",
      join: {
        title: "Join as Jury Member",
        description: "This report is seeking community jury members to help review the case. You can join as a jury member if you are not involved in this report.",
        button: "Join as Jury Member",
        confirm_title: "Join as Jury Member?",
        confirm_text: "Are you sure you want to join as a jury member for this case? You will be able to review the anonymized case and vote on its validity.",
        success_title: "Done",
        success_text: "You have successfully joined as a jury member. You will be able to vote once the jury voting phase begins.",
        error: "Error joining as jury member",
        cannot_join: "You cannot join this case.",
        already_member: "You are already a jury member for this case",
        not_recruiting: "This case is no longer looking for jurors.",
        jury_full: "This jury is already full.",
        seat_taken: "The last seat was just taken or voting already started.",
        recently_served: "You served on a jury recently. Wait a few days before joining another one.",
        not_eligible_case: "You cannot judge this case (you are linked to one of the parties or have an active sanction).",
        training_required: "Complete the Overwatch training to join juries.",
        cannot_join_reporter: "You cannot join as jury because you are the reporter",
        cannot_join_reported: "You cannot join as jury because you are the reported user",
        cannot_join_staff: "Staff members assigned to this ticket cannot join as jury",
        reputation_too_low: "Your reputation is too low to join as a jury member",
        max_active_duties: "You are already serving on the maximum number of active juries",
        staff_excluded: "Staff members cannot join as jury members",
        max_reached: "Maximum jury count ({max}) has been reached",
        current_count: "{current} of {max} jury members"
      },
      description: "Review the case and cast your vote.",
      case_details: "Case Details",
      evidence: "Evidence",
      case_review: "Jury Case Review",
      instructions: "Review all the evidence and details carefully. Your vote will help determine the outcome of this report. Vote 'Valid' if you believe the rules were broken, or 'Invalid' if the report lacks merit.",
      no_chat_for_jurors: "Jurors cannot write in the case chat. Base your vote only on the evidence shown.",
      parties: "Parties Involved",
      anonymous_user: "Anonymous User",
      view_evidence: "View Evidence",
      status: "Jury Status",
      votes: "Votes",
      
      voting: {
        title: "Cast Your Vote",
        valid: "Vote Valid",
        valid_description: "The report is legitimate and rules were broken.",
        invalid: "Vote Invalid",
        invalid_description: "The report is not justified or lacks evidence.",
        confirm: "Confirm Vote",
        already_voted: "You have already voted",
        your_vote: "Your Vote",
        deadline: "Voting Deadline",
        votes_cast: "Votes Cast"
      },

      results: {
        title: "Jury Results",
        valid_votes: "Valid Votes",
        invalid_votes: "Invalid Votes",
        outcome: "Outcome",
        report_valid: "Report Upheld",
        report_invalid: "Report Dismissed"
      },
      majority_decision: "Majority decision reached",

      assignment: {
        title: "Assign Jury",
        select_members: "Select Jury Members",
        search_users: "Search users...",
        selected: "Selected",
        assign_button: "Assign Jury",
        selecting: "Selecting Jury",
        min_required: "Minimum {count} jury members required"
      },
      selecting: "Selecting Jury",
      selecting_help: "Finding eligible jurors. This may take a moment.",
      retry: "Retry",
      selection_busy: "Jury selection is already in progress",
      assignment_failed: "Failed to assign jury",

      // Additional jury keys
      valid: "Valid",
      invalid: "Invalid",
      valid_votes: "Valid Votes",
      invalid_votes: "Invalid Votes",
      majority_reached: "Majority Reached",
      cast_vote: "Cast Your Vote",
      submit_vote: "Submit Vote",
      vote_submitted: "Your vote has been submitted",
      your_vote: "Your vote",
      confirm_vote_title: "Confirm Your Vote",
      result: "Jury Result",

      confirm_vote_text: "You are voting: {vote}. This action cannot be undone.",
      error_submitting_vote: "An error occurred while submitting your vote.",
      current_status: "Current Voting Status",
      members: "Jury Members",

      // Jury Messages
      messages: "Jury Messages",
      messages_remaining: "remaining",
      chat_limited: "Message limit applies during jury phase.",
      type_message: "Type your message...",
      send_message: "Send Message",
      no_messages: "No messages yet",
      message_limit_reached: "You have reached the maximum number of allowed messages.",
      error_sending_message: "An error occurred while sending the message.",
      jury_member: "Jury Member",
      
      // End voting early (staff)
      end_voting_early: "End Jury Voting",
      end_voting_early_title: "End Jury Voting Early?",
      end_voting_early_text: "This will end the jury voting phase with the current votes. This action will be logged. Continue?",
      mock_all_valid: "DEV: Mock jury → Valid",
      mock_all_invalid: "DEV: Mock jury → Invalid",
      mock_votes_title: "Mock jury votes? (DEV)",
      mock_votes_success: "Mocked {count} remaining jury vote(s).",
      mock_votes_error: "Failed to mock jury votes.",
      voting_ended_success: "Jury voting has been ended. The report will proceed to staff review.",
      error_ending_voting: "An error occurred while ending jury voting.",
      resolve_type_locked: "Resolve type is set based on jury result.",
      resolve_type_locked_staff_review:
        "Resolve type is prefilled from the jury vote tally. Override only for exceptional cases.",
      staff_review_note:
        "Staff can now review and apply final penalty blocks. If the report is valid, penalties will be applied to the reported user.",
      staff_review_note_invalid:
        "Staff can now review and close the report. No penalties will be applied as the report was deemed invalid."
    },

    // Staff Review
    staffReview: {
      title: "Staff Review",
      summary: "Report Summary",
      path: "Resolution Path",
      paths: {
        accepted: "User Accepted ({reduction}% reduction)",
        agreement: "Agreement Reached in Conciliation",
        jury_valid: "Jury Vote: Valid",
        jury_invalid: "Jury Vote: Invalid",
        conciliation_expired: "Conciliation Expired (No Agreement)",
        direct: "Direct Staff Review"
      },
      penalties: {
        title: "Penalty Blocks",
        original: "Original Suggestion",
        original_desc: "What the reporter requested",
        current: "Current",
        current_desc_reduced: "After {reduction}% reduction",
        current_desc_agreed: "Agreed in conciliation",
        current_desc_default: "From original suggestion",
        final: "Final Decision",
        final_desc: "Your final penalty selection",
        total_severity: "Total Severity"
      },
      resolution: {
        title: "Resolution",
        type: "Resolution Type",
        types: {
          unresolved: "Unresolved",
          agreement: "Agreement",
          accept_guilt: "Accept Guilt",
          valid: "Valid (Report Upheld)",
          invalid: "Invalid (Report Dismissed)"
        },
        notes: "Staff Notes",
        notes_placeholder: "Add any notes about your decision (optional but recommended)..."
      },
      additional_info: "Additional Information",
      view_evidence: "View Evidence",
      view_description: "View Description",
      view_conciliation: "View Conciliation History",
      view_jury: "View Jury Results",
      view_audit: "View Audit Log",
      close_button: "Close Report & Apply Penalties",
      cancel: "Cancel"
    },

    // User score related translations
    user: {
      score: "Score",
      score_leaderboard: "Leaderboard",
      honorable: "Honorable User",
      honorable_hint: "Unlocked by correct jury votes and reputation"
    },

    // Admin: report settings panel (ENG-1758 additions)
    report_settings_admin: {
      default_hours: "Default: {hours} hours",
      staff_review_no_timer: "Staff Review has no timer: it waits for a staff member to close the report.",
      jury_selection_hours: "Jury Selection Deadline",
      jury_selection_hours_help: "Time to seat a jury; afterwards the case goes to Staff Review",
      post_jury_choice_hours: "Post-Jury Choice Deadline",
      post_jury_choice_hours_help: "Time for the parties to accept or escalate the jury result; afterwards it is accepted automatically",
      staff_voting_hours: "Staff Voting Deadline",
      staff_voting_hours_help: "Time for the staff vote; afterwards it resolves on the votes cast (tie goes to Staff Review)",
      agreement_close_hours: "Agreement Auto-Close",
      agreement_close_hours_help: "Time after a conciliation agreement before it closes applying the agreed penalties (immediate if there are none)",
      staff_vote_subtitle: "Multi-staff vote after a post-jury accept or appeal.",
      threshold_mode: "Decision Rule",
      threshold_mode_majority: "Majority of votes cast",
      threshold_mode_percent: "Percent of pool (legacy)",
      threshold_mode_help: "Any minimum is capped at the staff who commented in the last 7 days",
      min_votes: "Minimum Votes",
      min_votes_help: "Votes needed before a majority decides (default 3)"
    },

    // Overwatch (jury) player profile + training
    notFound: {
      title: "Page not found",
      message: "The page you are looking for does not exist or was moved.",
      home: "Back to home",
    },
    reportQueue: {
      backHome: "Back to home",
      title: "Report queue",
      nav: "Report queue",
      age: "Age",
      status: "Status",
      report: "Report",
      parties: "Reporter → accused",
      assignee: "Assignee",
      actions: "Actions",
      waiting: "Waiting on staff",
      answered: "Answered",
      take: "Take",
      view: "View",
      reportAgainst: "Report against {name}",
      taken: "Assigned to you",
      filters: "Filters",
      unassignedOnly: "Unassigned only",
      waitingOnly: "Waiting on staff only",
      category: "Category",
      allCategories: "All categories",
      olderThan: "Older than",
      anyAge: "Any age",
      days: "{n} days",
      refresh: "Refresh",
      loading: "Loading...",
      empty: "No reports match these filters.",
      showing: "{shown} of {total} reports",
      page: "Page {page} of {pages}",
      ageMinutes: "{n} min",
      ageHours: "{n} h",
      ageDays: "{n} d",
      openTicket: "Open report {id}",
    },
    overwatch: {
      title: "Overwatch",
      subtitle: "Serve as a community juror, earn reputation, climb the ranks.",
      loading: "Loading profile",
      locked: "You need at least {min} reputation (you have {score}). Keep improving to rejoin.",
      rank_label: "Rank",
      reputation: "Reputation",
      xp_progress: "{current} / {next} XP to next level",
      correct_votes: "Correct verdicts",
      eligibility: "Jury access",
      level: "Level {level}",
      juror_n: "Juror {n}",
      actions_label: "Overwatch actions",
      meta_honorable: "Standing",
      status_active: "Eligible",
      status_locked: "Locked",
      train_cta: "Train Overwatch",
      train_cta_short: "Train",
      enter_jury_cta: "Find a case",
      enter_jury_cta_short: "Find case",
      enter_jury_locked_hint: "Complete the training first to unlock jury cases.",
      back_home: "Back",
      back_home_short: "Back",
      back_profile: "My Overwatch",
      leaderboard: "Top jurors",
      leaderboard_empty: "No rankings yet.",
      you: "You",
      my_profile: "My Overwatch",
      train_title: "Overwatch training",
      train_subtitle: "Practice the full jury flow on a dummy case. Nothing is real.",
      train_sandbox_notice: "Sandbox mode: votes and chat here are not saved.",
      replay_tour: "Replay tour",
      train_status_badge: "Jury voting",
      train_status_text: "Practice case: review evidence, then cast your vote.",
      train_deadline: "Voting closes in 48 hours (demo)",
      train_accept: "Accept",
      train_dispute: "Dispute",
      train_conciliation: "Conciliation (demo)",
      train_conciliation_body: "Parties can trade proposed sanctions before calling a jury.",
      train_chat: "Case chat",
      train_chat_sample: "Reporter: Please review the attached clip carefully.",
      train_chat_placeholder: "Message disabled in training",
      join_locked_hint: "Reputation too low to join juries",
      locked_training: "Complete the Overwatch training to unlock jury duty. Finishing it grants {start} reputation.",
      training_required_hint: "Complete the training to join juries",
      train_complete_hint: "Finish the guided tour to complete your training and unlock jury duty.",
      train_completed: "Training completed. Jury duty unlocked.",
      train_completed_score: "Training completed. You earned {start} reputation and can now join juries.",
      train_complete_error: "Could not save your training progress. Try finishing the tour again.",
      admin_min_score_rule: "Players must complete the Overwatch training AND reach this score. Capped at the training start score ({start}).",
      admin_min_score_clamped: "Above the training start score: the server will use {start}.",
      admin_training_start_score: "Training Start Score",
      admin_training_start_score_help: "Reputation granted once when a player completes the Overwatch training",
      rank: {
        rookie: "Rookie",
        observer: "Observer",
        juror: "Juror",
        sentinel: "Sentinel",
        arbiter: "Arbiter",
        vanguard: "Vanguard",
        honorable: "Honorable",
        legend: "Legend",
      },
    },

    // Item picker (return-item penalties, etc.)
    item: {
      search_placeholder: "Search items...",
      type_to_search: "Type to search and select an item",
      no_results: "No items found",
      selected_items: "Selected items",
    },

    // Penalty block related translations
    penalty: {
      select_blocks: "Select Penalty Blocks",
      search_blocks: "Search blocks...",
      all_categories: "All Categories",
      statusActive: "Active",
      statusInactive: "Inactive",
      refresh: "Refresh",
      disable: "Disable",
      quantity: "Quantity",
      notes: "Notes",
      notes_placeholder: "Add notes (optional)",
      selected_blocks: "Selected Blocks",
      severity: "Severity",
      select_items: "Select items",
      item_block_help: "Search and select the item types and quantities for this penalty.",
      
      // Extended penalty translations
      items_to_return: "Items to Return",
      deactivate: "Deactivate",
      confirm_deactivate: "Deactivate Penalty Block",
      confirm_deactivate_text: "Are you sure you want to deactivate this penalty block?",
      block_created: "Penalty block created",
      block_updated: "Penalty block updated",
      block_activated: "Penalty block activated",
      block_deactivated: "Penalty block deactivated",
      error_saving_block: "Error saving block",
      error_activating_block: "Error activating block",
      error_deactivating_block: "Error deactivating block",

      blocks: "Penalty Blocks",
      block: "Penalty Block",
      no_blocks: "No penalty blocks available",
      no_selection: "No penalties selected",
      add_block: "Add Block",
      remove_block: "Remove Block",
      suggested_blocks: "Suggested Penalty Blocks",
      agreed_blocks: "Agreed Penalty Blocks",
      final_blocks: "Final Penalty Blocks",
      history: "Penalty History",
      
      severity_levels: {
        low: "Low",
        medium: "Medium",
        high: "High",
        severe: "Severe",
        maximum: "Maximum"
      },
      
      categories: {
        warning: "Warning",
        ban: "Ban",
        fine: "Fine",
        restriction: "Restriction",
        penalty: "Penalty",
        item: "Item",
        sanction: "Sanction",
        other: "Other"
      },
      
      management: {
        title: "Penalty Block Management",
        create: "Create New Block",
        edit: "Edit Block",
        deactivate: "Deactivate",
        activate: "Activate",
        code: "Code",
        code_help: "Unique identifier (e.g., BAN_7D)",
        name_en: "Name (English)",
        name_es: "Name (Spanish)",
        description_en: "Description (English)",
        description_es: "Description (Spanish)",
        category: "Category",
        is_active: "Active",
        confirm_deactivate: "Are you sure you want to deactivate this block?",
        category_placeholder: "e.g., ban, warning, fine, Item",
        category_help: "Use \"Item\" category to enable item selection for this block",
      },

      // Trade related
      trade_proposal: "Trade Proposal",
      proposed_by: "Proposed by",
      proposed_blocks: "Proposed Blocks",
      active_trades: "Active Trade Proposals",
      agreement_reached: "Agreement reached",
      with_trade_proposal: "With Trade",
      propose_trade: "Propose Trade",
      propose_new_trade: "Propose New Penalty Trade",
      trade_message: "Message (optional)",
      trade_message_placeholder: "Explain your proposal...",
      submit_trade: "Submit Proposal",
      counter_trade: "Counter Proposal",
      counter_trade_message_placeholder: "Explain your counter-proposal...",
      submit_counter: "Submit Counter",
      accept_trade: "Accept Trade",
      reject_trade: "Reject Trade",
      counter_proposal_reference: "This is a counter to a previous proposal",
      
      trade_status: {
        pending: "Pending",
        accepted: "Accepted",
        rejected: "Rejected",
        countered: "Countered",
        expired: "Expired"
      },
      
      confirm_accept_trade: "Accept Trade Proposal",
      confirm_accept_trade_text: "Are you sure you want to accept this trade proposal? This will create an agreement.",
      confirm_reject_trade: "Reject Trade Proposal",
      confirm_reject_trade_text: "Are you sure you want to reject this trade proposal?",
      error_accepting_trade: "An error occurred while accepting the trade.",
      error_rejecting_trade: "An error occurred while rejecting the trade.",
      error_proposing_trade: "An error occurred while proposing the trade.",
      error_countering_trade: "An error occurred while countering the trade."
    },

    // Notifications / Toasts
    notifications: {
      report_accepted: "Report has been accepted",
      report_disputed: "Report has been disputed",
      conciliation_started: "Conciliation phase started",
      new_message: "New message received",
      trade_proposed: "New penalty trade proposal",
      trade_accepted: "Trade proposal accepted",
      trade_rejected: "Trade proposal rejected",
      trade_countered: "Counter-proposal received",
      agreement_reached: "Agreement reached",
      conciliation_expired: "Conciliation period expired",
      jury_assigned: "Jury has been assigned",
      jury_vote_recorded: "Your vote has been recorded",
      jury_complete: "Jury voting complete",
      report_closed: "Report has been closed",
      deadline_warning: "{type} deadline in {hours} hours",
      error_generic: "An error occurred. Please try again.",
      success_generic: "Action completed successfully."
    },

    // Common / Shared
    panel: {
      noAccess: {
        title: "You do not have access to this section",
        back: "Back to overview",
        body: "Your account does not have the permissions needed to view it. If you think this is a mistake, ask an administrator.",
      },
      table: {
        refresh: "Refresh",
        loading: "Loading...",
        showing: "Showing {shown} of {total} {item}",
        page: "Page {page} of {pages}",
        filters: "Filters",
        downloadCsv: "Download CSV",
        downloadJson: "Download JSON",
        empty: "No data",
      },
      assistant: {
        hide: "Hide",
        title: "Staff assistant",
        close: "Close",
        conversations: "Conversations",
        newChat: "New",
        placeholder: "Ask for a summary, next steps, results...",
        copy: "Copy",
        chat: "Chat",
        conversation: "Conversation",
        closeList: "Close list",
        viewChats: "View conversations",
        resize: "Resize"
      },
      config: {
        "title": "Configuration",
        "subtitle": "Feature flags and system settings. Changes apply to the live system.",
        "refresh": "Refresh",
        "empty": "No configurations found.",
        "loading": "Loading...",
        "searchPlaceholder": "Search by name or description",
        "filterLabel": "Filter flags",
        "filter": {
          "all": "All",
          "on": "On",
          "off": "Off",
          "changed": "Changed"
        },
        "flagsTitle": "Feature flags",
        "groups": {
          "reports": "Reports and Overwatch",
          "tickets": "Tickets",
          "classifier": "Classifier",
          "ai": "AI",
          "login": "Login",
          "performance": "Performance",
          "other": "Other"
        },
        "statOn": "flags on of {total}",
        "statOff": "flags off",
        "statChanged": "changed from default",
        "on": "On",
        "off": "Off",
        "changed": "Default: {value}",
        "changedShort": "Changed",
        "reset": "Reset to default",
        "jsonFlagHint": "Other fields of this setting are in Advanced settings.",
        "advancedTitle": "Advanced settings",
        "advancedHint": "Numbers, text, prompts and JSON. Open an item to edit it.",
        "value": "Value",
        "defaultIs": "Default:",
        "empty_value": "(empty)",
        "format": "Format JSON",
        "cancel": "Cancel",
        "save": "Save",
        "invalidJson": "This is not valid JSON.",
        "invalidNumber": "Enter a number.",
        "updatedBy": "Updated by",
        "system": "System",
        "noMatches": "No matches.",
        "confirmTitle": "Change {key}?",
        "confirmApply": "Apply",
        "whitelistWarning": "While this is off, every report waits for staff approval. Once on, only the players listed in protected_report_targets are held. Make sure that list is set up first.",
        "saved": "{key} updated.",
        "saveFailed": "Could not update {key}. Nothing was changed.",
        "loadFailed": "Could not load the configuration.",
        "names": {
          "FEATURE_SIMPLE_REPORT_FLOW": "Simplified report form",
          "FEATURE_SIMPLE_TICKET_FLOW": "Simplified ticket form",
          "SIMPLE_TICKET_REPORT_DETECTION": "Detect reports in tickets",
          "FEATURE_JURY_REPORTS": "Jury for reports",
          "REPORT_AUTO_ASSIGN": "Auto-assign reports",
          "IDLE_AUTOCLOSE": "Close idle tickets",
          "DUPLICATE_GUARD": "Duplicate report guard",
          "FEATURE_CATEGORY_SUGGESTIONS": "Category suggestions",
          "CLASSIFIER_SUGGEST_REROUTE": "Suggest rerouting",
          "AI_ENABLED": "AI features",
          "FEATURE_AUTH_CODE_FLOW": "Authorization code login",
          "TICKET_LIST_PROJECTION": "Slim ticket lists",
          "TICKET_PATCH_EVENTS": "Ticket patch events",
          "FEATURE_REPORT_EVIDENCE_RULES": "Report evidence rules",
          "FEATURE_STAFF_ID_REDACTION": "Hide player ids from staff",
          "FEATURE_REPORT_QUEUE": "Report queue",
          "protected_report_approval_enabled": "Protected report approval",
          "protected_report_whitelist_enabled": "Approval only for listed players",
          "CACHE_METRICS_ENABLED": "Cache metrics"
        },
        "descriptions": {
          "FEATURE_SIMPLE_REPORT_FLOW": "One-form report creation. The old multi-step flow is the fallback.",
          "FEATURE_SIMPLE_TICKET_FLOW": "One-form ticket creation.",
          "SIMPLE_TICKET_REPORT_DETECTION": "Suggest the report flow when a ticket looks like a report.",
          "FEATURE_JURY_REPORTS": "Send eligible reports to the Overwatch jury.",
          "REPORT_AUTO_ASSIGN": "Assign open reports to staff automatically.",
          "IDLE_AUTOCLOSE": "Close tickets with no activity after the configured time.",
          "DUPLICATE_GUARD": "Block repeated reports for the same case.",
          "FEATURE_CATEGORY_SUGGESTIONS": "Suggest a ticket category from the classifier.",
          "CLASSIFIER_SUGGEST_REROUTE": "Suggest moving a ticket to another category.",
          "AI_ENABLED": "Master switch for all AI features. Needs the Gemini key.",
          "FEATURE_AUTH_CODE_FLOW": "Use the authorization code flow to log in.",
          "TICKET_LIST_PROJECTION": "Return only the fields lists need.",
          "TICKET_PATCH_EVENTS": "Send ticket changes over the socket as small patches.",
          "FEATURE_REPORT_EVIDENCE_RULES": "Enforce the evidence limits and requirements when creating reports. Off matches prod.",
          "FEATURE_STAFF_ID_REDACTION": "Redact account ids in what non-admin staff see.",
          "FEATURE_REPORT_QUEUE": "Show the report queue to staff.",
          "protected_report_approval_enabled": "Master switch: reports against protected players wait for staff approval.",
          "protected_report_whitelist_enabled": "Only hold reports against the players in protected_report_targets. Off holds every report.",
          "CACHE_METRICS_ENABLED": "Record cache hits and misses."
        }
      },
      dashboard: {
        generalInfo: "General info",
        leaderboards: "User leaderboards",
        mostTickets: "Most tickets submitted",
        mostActive: "Most active",
        noDataYet: "No data yet"
      },
      incidents: {
        status: {
          open: "Open",
          investigating: "Investigating",
          resolved: "Resolved",
          closed: "Closed"
        },
        statusLabel: "Status:",
        description: "Description",
        author: "Author",
        message: "Message",
        dateTime: "Date/time:",
        addEntry: "Add entry",
        cancel: "Cancel",
        update: "Update",
        log: {
          title: "Incident log",
          newIncident: "New incident",
          empty: "No incidents found.",
          createTitle: "Create incident",
          titlePlaceholder: "Title",
          create: "Create",
          timeline: "Timeline"
        },
        detail: {
          back: "Back to list",
          downloadMarkdown: "Download as Markdown",
          downloadPostmortem: "Download postmortem",
          generating: "Generating...",
          created: "Created: {date}",
          entries: "Entries",
          edit: "Edit",
          delete: "Delete",
          save: "Save",
          confirmDelete: "Are you sure you want to delete this entry?"
        },
        errors: {
          updateStatus: "Failed to update status. Please try again.",
          downloadMarkdown: "Failed to download Markdown. Please try again.",
          postmortem: "Failed to generate postmortem. Please try again.",
          updateEntry: "Failed to update entry.",
          deleteEntry: "Failed to delete entry."
        }
      },
      penaltyBlocks: {
        codePlaceholder: "e.g. BAN_7D",
        errorTitle: "Error",
        successTitle: "Success",
        loadFailed: "Failed to load penalty blocks",
        codeRequired: "Code is required",
        codeTooLong: "Code must be 20 characters or less",
        nameEnRequired: "English name is required",
        severityRange: "Severity must be between 1 and 10",
        created: "Penalty block created successfully",
        updated: "Penalty block updated successfully",
        deactivated: "Penalty block deactivated successfully",
        activated: "Penalty block activated successfully",
        saveFailed: "Failed to save penalty block",
        deactivateFailed: "Failed to deactivate penalty block",
        activateFailed: "Failed to activate penalty block"
      },
      classifier: {
        title: "Classifier",
        window: "Window",
        since: "Flag on since",
        days: "Last {n} days",
        loadFailed: "Could not load the classifier data.",
        model: "Active model",
        noModel: "No active model",
        trainedAt: "Trained at",
        accuracy: "Accuracy top-1 / top-3",
        labels: "Labels",
        threshold: "Threshold",
        effectiveThreshold: "effective",
        flags: "Flags",
        flag: { simpleTicketFlow: "Simple ticket flow", simpleReportFlow: "Simple report flow", categorySuggestions: "Suggestions" },
        on: "on",
        off: "off",
        truncated: "A period has more tickets than the sample limit; figures use the newest ones.",
        impactTitle: "Before and after",
        impactHelp: "After: the last {days} days. Before: the {days} days earlier. Watch the catch-all share go down, the override rate stay under 20% and the first response not get worse.",
        dailyTitle: "Per day (UTC)",
        noTickets: "No tickets in this window.",
        day: "Day",
        type: "Type",
        period: "Period",
        types: { support: "Support", report: "Report" },
        periods: { before: "Before", after: "After" },
        col: {
          total: "Tickets",
          catchAllShare: "Catch-all",
          withDecision: "With decision",
          bySource: "Auto / fallback / player / none",
          overrideRate: "Overrides",
          autoShare: "Auto share",
          medianFirstResponse: "1st response (median)",
          p90FirstResponse: "1st response (p90)",
          medianClose: "Close (median)"
        }
      },
      reportSettings: {
        title: "Report system settings",
        subtitle: "Configure deadlines, user scores, jury settings, and other reporting system parameters.",
        deadlines: {
          title: "Report deadlines",
          subtitle: "Configure time limits for each phase of the reporting process.",
          response: "Response deadline",
          conciliation: "Conciliation deadline",
          juryVoting: "Jury voting deadline",
          responseHelp: "Time for the reported user to respond (accept or dispute)",
          conciliationHelp: "Time for negotiations in the conciliation phase",
          juryVotingHelp: "Time for jury members to cast their votes"
        },
        common: {
          hours: "hours",
          pts: "pts",
          days: "days",
          resetDefaults: "Reset defaults",
          save: "Save",
          defaultHours: "Default: {n} hours",
          yes: "Yes",
          no: "No",
          enabled: "Enabled",
          disabled: "Disabled",
          required: "Required",
          optional: "Optional",
          error: "Error",
          success: "Success",
          info: "Info"
        },
        scores: {
          title: "User score values",
          subtitle: "Configure point values for various report outcomes.",
          outcomesTitle: "Report outcomes",
          acceptanceTitle: "Acceptance and jury participation",
          severityTitle: "Severity-based deduction",
          validReporter: "Valid - Reporter",
          validReported: "Valid - Reported",
          invalidReporter: "Invalid - Reporter",
          invalidReported: "Invalid - Reported",
          validReporterHelp: "Reporter gains (valid report)",
          validReportedHelp: "Reported loses (valid report)",
          invalidReporterHelp: "Reporter loses (invalid report)",
          invalidReportedHelp: "Reported gains (invalid report)",
          acceptReported: "Accept - Reported",
          acceptReportedHelp: "Base penalty for accepting",
          juryParticipation: "Jury participation",
          juryParticipationHelp: "Points for voting",
          juryCorrectVote: "Jury correct vote",
          juryCorrectVoteHelp: "Bonus for correct vote",
          juryIncorrectVote: "Jury incorrect vote",
          juryIncorrectVoteHelp: "Penalty for incorrect vote",
          perSeverityPoint: "Per severity point",
          perSeverityPointHelp: "Deduction per severity point"
        },
        jury: {
          title: "Jury settings",
          subtitle: "Configure jury system parameters and eligibility requirements.",
          compositionTitle: "Jury composition",
          eligibilityTitle: "Eligibility requirements",
          size: "Jury size",
          sizeHelp: "Members per case (3-15)",
          maxCount: "Max jury count",
          maxCountHelp: "Maximum members allowed (including auto-assigned)",
          minVotes: "Min votes required",
          minVotesHelp: "Minimum votes for decision",
          majorityType: "Majority type",
          majorityTypeHelp: "Voting threshold",
          majoritySimple: "Simple (50%+1)",
          majoritySuper: "Super (2/3)",
          minScore: "Min user score",
          minAccountAge: "Min account age",
          minAccountAgeHelp: "Minimum account age",
          maxActiveDuties: "Max active duties",
          maxActiveDutiesHelp: "Max concurrent assignments",
          excludeStaff: "Exclude staff",
          excludeStaffHelp: "Staff cannot be jury",
          excludeSameFaction: "Exclude same faction",
          excludeSameFactionHelp: "Block faction mates of parties",
          excludeKnownUsers: "Exclude known users",
          excludeKnownUsersHelp: "Block mutual known accounts",
          rotation: "Jury rotation",
          rotationHelp: "Exclude recent jurors (0 = off)",
          honorableMinScore: "Honorable min score",
          honorableMinScoreHelp: "Score needed for Honorable User",
          honorableMinVotes: "Honorable min correct votes",
          honorableMinVotesHelp: "Correct votes needed (rewards in gamemode config)"
        },
        staffReview: {
          title: "Staff review voting",
          voteMode: "Vote mode",
          modeAny: "Any staff in group",
          modeAutoAssign: "Auto-assign random staff",
          voteModeHelp: "Who may cast staff votes",
          autoAssignCount: "Auto-assign count",
          autoAssignCountHelp: "Used when the mode is auto-assign",
          threshold: "Threshold %",
          thresholdHelp: "Accept or reject votes needed",
          poolSize: "Pool size (any mode)",
          poolSizeHelp: "Denominator when the mode is any"
        },
        reduction: {
          title: "Penalty reduction",
          subtitle: "Configure reduction incentives for accepting reports.",
          percent: "Reduction percent",
          percentHelp: "% reduction on accept",
          appliesTo: "Applies to",
          severity: "Severity",
          quantity: "Quantity",
          both: "Both",
          appliesToHelp: "What gets reduced",
          minSeverity: "Min severity after",
          minSeverityHelp: "Floor after reduction"
        },
        general: {
          title: "General settings",
          subtitle: "Configure general report system parameters.",
          maxBlocks: "Max penalty blocks",
          maxBlocksHelp: "Max blocks per report",
          maxEvidence: "Max evidence items",
          maxEvidenceHelp: "Max evidence per report",
          maxJuryMessages: "Max messages during jury phase",
          maxJuryMessagesHelp: "Max messages per user during jury phase",
          allowAnonymous: "Allow anonymous reports",
          allowAnonymousHelp: "Anonymous reports",
          requireEvidence: "Require evidence",
          requireEvidenceHelp: "Evidence requirement"
        },
        tabs: {
          deadlines: "Deadlines",
          scores: "User scores",
          jury: "Jury settings",
          staffReview: "Staff review",
          reduction: "Penalty reduction",
          general: "General"
        },
        messages: {
          loadFailed: "Failed to load settings",
          saved: "{section} saved successfully",
          saveFailed: "Failed to save settings",
          reset: "{section} reset to defaults. Click Save to apply."
        },
        sections: {
          deadlines: "Deadlines",
          scores: "User scores",
          jury: "Jury settings",
          staffReview: "Staff review",
          reduction: "Penalty reduction",
          general: "General settings"
        }
      },
      sidebar: {
        title: "Support panel",
        items: {
          dashboard: "Dashboard",
          staff: "Staff",
          tickets: "Tickets",
          users: "Users",
          tokens: "Tokens",
          config: "Config",
          "penalty-blocks": "Penalty blocks",
          "report-settings": "Report settings",
          classifier: "Classifier",
          incidents: "Incidents"
        }
      },
      staff: {
        title: "Staff performance",
        itemName: "staff entries",
        filters: {
          staffMember: "Staff member",
          status: "Status",
          ticketType: "Ticket type",
          dateFrom: "Date from",
          dateTo: "Date to",
          sortBy: "Sort by",
          itemsPerPage: "Items per page",
          apply: "Apply filters"
        },
        columns: {
          staff: "Staff",
          date: "Date",
          reports: "Reports",
          support: "Support tickets",
          total: "Total tickets"
        },
        options: {
          allStaff: "All staff",
          all: "All",
          opened: "Opened",
          closed: "Closed",
          allTypes: "All types",
          reportsOnly: "Reports only",
          supportOnly: "Support only"
        },
        sort: {
          date: "Date",
          staff: "Staff name",
          reports: "Reports count",
          support: "Support count",
          total: "Total tickets"
        },
        errors: {
          downloadCsv: "Failed to download CSV. Please try again.",
          downloadJson: "Failed to download JSON. Please try again."
        }
      },
      tickets: {
        title: "Tickets management",
        downloadCsv: "Download CSV",
        downloadJson: "Download JSON",
        refresh: "Refresh",
        filters: "Filters",
        ticketType: "Ticket type",
        search: "Search",
        group: "Group",
        sortBy: "Sort by",
        createdFrom: "Created from",
        createdTo: "Created to",
        source: "Source",
        itemsPerPage: "Items per page",
        status: "Status",
        support: "Support",
        reports: "Reports",
        open: "Open",
        closed: "Closed",
        mine: "Mine",
        unassigned: "Unassigned",
        juryDuty: "Jury duty",
        newest: "Newest first",
        oldest: "Oldest first",
        latestComment: "Latest comment",
        oldestComment: "Oldest comment",
        inGame: "In-game",
        web: "Web",
        searchPlaceholder: "Search tickets...",
        allGroups: "All groups",
        applyFilters: "Apply filters",
        showing: "Showing {shown} of {total} tickets",
        page: "Page {page} of {pages}",
        colTitle: "Title",
        colType: "Type",
        colCategory: "Category",
        colCreatedBy: "Created by",
        colAssignedTo: "Assigned to",
        colComments: "Comments",
        colCreated: "Created",
        colLastComment: "Last comment",
        typeReport: "Report",
        loading: "Loading tickets...",
        csvFailed: "Failed to download CSV. Please try again.",
        jsonFailed: "Failed to download JSON. Please try again."
      },
      tokens: {
        title: "Access token manager",
        createNew: "Create new token",
        active: "Active tokens",
        total: "Total tokens",
        expired: "Expired tokens",
        inactive: "Inactive tokens",
        tableTitle: "Access tokens",
        colName: "Name",
        colEndpoints: "Endpoints",
        colPermissions: "Permissions",
        colCreatedBy: "Created by",
        colCreated: "Created",
        colExpires: "Expires",
        colStatus: "Status",
        colActions: "Actions",
        more: "+{n} more",
        read: "Read",
        write: "Write",
        admin: "Admin",
        createTitle: "Create access token",
        tokenName: "Token name",
        description: "Description (optional)",
        namePlaceholder: "e.g. API integration token",
        descriptionPlaceholder: "What is this token for?",
        endpointsCount: "Endpoints ({n})",
        loadingEndpoints: "Loading endpoints...",
        permRead: "Read (GET requests)",
        permWrite: "Write (POST/PUT requests)",
        permAdmin: "Admin (DELETE requests)",
        cancel: "Cancel",
        create: "Create token",
        selectEndpoint: "Please select at least one endpoint",
        selectPermission: "Please select at least one permission",
        createFailed: "Failed to create token. Please try again.",
        copied: "JWT token copied to clipboard.",
        copyFailed: "Failed to copy token. Please copy it manually.",
        confirmDeactivate: "Are you sure you want to deactivate this token?",
        deactivateFailed: "Failed to deactivate token.",
        activateFailed: "Failed to activate token.",
        confirmDelete: "Are you sure you want to delete this token? This cannot be undone.",
        deleteFailed: "Failed to delete token.",
        titleExpired: "Token expired",
        titleInactive: "Token inactive",
        titleCopy: "Copy token",
        statusExpired: "Expired",
        statusInactive: "Inactive",
        statusActive: "Active",
        created: "Token created successfully.\n\nJWT token: {jwt}\n\nToken ID: {id}"
      }
    },
    common: {
      yesterday: "Yesterday",
      daysAgo: "days ago",
      loading: "Loading...",
      saving: "Saving...",
      save: "Save",
      cancel: "Cancel",
      confirm: "Confirm",
      delete: "Delete",
      edit: "Edit",
      create: "Create",
      close: "Close",
      back: "Back",
      next: "Next",
      submit: "Submit",
      search: "Search",
      filter: "Filter",
      all: "All",
      none: "None",
      yes: "Yes",
      no: "No",
      or: "or",
      and: "and",
      items: "items",
      selected: "selected",
      required: "Required",
      optional: "Optional",
      error: "Error",
      success: "Success",
      warning: "Warning",
      info: "Info",
      unknown: "Unknown"
    },

    // Time / Deadlines
    time: {
      hours: "hours",
      hour: "hour",
      minutes: "minutes",
      minute: "minute",
      seconds: "seconds",
      second: "second",
      days: "days",
      day: "day",
      remaining: "remaining",
      expired: "Expired",
      deadline: "Deadline",
      deadline_response: "Response Deadline",
      deadline_conciliation: "Conciliation Deadline",
      deadline_jury: "Voting Deadline"
    },

    titleComplete: "Title to display: ",
    location_selected: "Selected",
    error_title: "Enter a title to select date",
    showMapButton: "View on map",
    copyMapId: "Copy map ID",
    enableMapInstance: "Enable map instance",
    enableMapInstanceConfirm: "Enable map instance",
    enableMapInstanceSuccess: "Map instance enabled successfully.",
    enableMapInstanceError: "Failed to enable the map instance.",
    disableMapInstance: "Disable map instance",
    disableMapInstanceConfirm: "Disable map instance",
    disableMapInstanceSuccess: "Map instance disabled successfully.",
    disableMapInstanceError: "Failed to disable the map instance.",
    events: {
      select: ["External software", "YouTube links", "No"]
    },
    create_event_error_title: "Technical Issues Creating Your Event?",
    create_event_error_info: "Describe the technical issue that occurred while scheduling your event.",
    create_event_error_info_more: "This field should only be used in case of a technical problem.",
    create_event_error_button: "Submit",
    load_more: "Load more",
    fetchMoreComments: "Load more comments",
    scrollToBottom: "Scroll to bottom",
    suggestedResponses: "Suggested responses",
    useResponse: "Use response",
    editResponse: "Edit response",
    save: "Save",
    createdBy: "Created by",
  },
  es: {
    main_title: "GTAHUB - Soporte",
    apply: "Aplicar",
    edit: "Editar",
    description: "Descripción",
    loading: "Cargando...",
    filter: "Filtrar...",
    copied: "Copiado",
    game: "Juego",
    web: "Web",
    showOrHideHelp: "Para mostrar u ocultar usa",
    or: "o",
    tickets_created: "Tickets creados",
    reports_created: "Reportes creados",
    create_new_ticket: "Crear un nuevo ticket",
    create_new_ticket_description: "Elige una categoría para crear un ticket.",
    create_ticket_button: "Crear ticket",
    create_report_button: "Crear reporte",
    ticket_created_by: "De:",
    ticket_assigned_to: "Asignado:",
    ticket_unassigned: "Sin asignar",
    duplicate_ticket_title: "Ya tienes uno abierto",
    duplicate_ticket_open: "Abrir ticket existente",
    take: "Tomar",
    close: "Cerrar",
    reopen: "Reabrir",
    comment: "Comentar",
    admin_comment: "Staff",
    staffComments: "Comentarios del Staff",
    edited: "Editado",
    takeAndComment: "Tomar y comentar",
    commentAndClose: "Comentar y cerrar",
    commentAndReopen: "Comentar y reabrir",
    noAssigned: "Nadie está asignado.",
    assignedTo: "Tomado por:",
    category: "Categoría:",
    open: "Abierto",
    closed: "Cerrado",
    ticketName: "ticket",
    reportName: "reporte",
    hasBeenClosed: "ha cerrado el",
    hasBeenReopened: "ha reabierto",
    hasBeenEscalated: "ha escalado",
    hasBeenTook: "ha tomado el",
    hasBeenAssignedBy: "ha sido asignado por",
    hasBeenUnassignedBy: "ha sido desasignado por",
    hasBeenUntook: "ha dejado el",
    supportName: "Soporte",
    reportsName: "Reportes",
    openeds: "Abiertos",
    closeds: "Cerrados",
    mine: "Asignados a mi",
    jury_duty: "Deber de Jurado",
    attachments: "Imágenes y/o vídeos",
    noAttachments: "No hay vídeos ni imágenes adjuntadas.",
    attachmentsHelp: "Se recomienda utilizar https://gofile.io/ para subir las pruebas. Ingresa URL's de las imágenes o vídeos que tengas. Si tienes más de uno, presiona el botón de 'añadir'.",
    attachmentsMax: "Máximo {max} elementos",
    attachmentLinkInvalid: "Enlace no permitido: usa {hosts}",
    attachmentLinkInvalidMore: "Enlace no permitido: usa {hosts} y {n} más",
    warning: "Advertencia",
    hubHour: "Hora del servidor (HUB):",
    cancel: "Cancelar",
    groups: "Grupos",
    stars: "Estrellas",
    roles: "Roles",
    users: "Usuarios",
    select_all: "Seleccionar todo",
    logout: "Salir",
    hasBeenRequestedMoreResponses: "solicitó más intervenciones al staff.",
    unassigned: "Sin asignar",
    supportAlert: "Nunca solicitaremos datos privados o sensibles a través de ningún medio. Si recibes solicitudes de este tipo, ten en cuenta que podrían ser estafas. La seguridad de tus datos es nuestra máxima prioridad. Recuerda que la descarga del launcher oficial se realiza únicamente desde nuestra página web. Evita descargarlo de sitios no autorizados o que te sean enviados por terceros, ya que podrían contener virus u otros elementos maliciosos.",
    reviewTitle: "Dar opinión",
    review_one_star: "Muy malo, no resolvieron mi problema",
    review_two_stars: "Malo, no resolvieron mi problema",
    review_three_stars: "Regular, pero se resolvió mi problema",
    review_four_stars: "Bueno, resolvieron mi problema",
    review_five_stars: "Excelente, resolvieron mi problema",
    write_your_review: "Escribe tu opinión...",
    send_review: "Enviar opinión",
    review_sended: "Opinión enviada, gracias.",
    myReviews: "Mi valoración",
    statistics: "Estadísticas",
    responseTime: "Tiempo de respuesta",
    error: "Error",

    delete: "Eliminar",
    deleteCommentTitle: "Eliminar comentario",
    deleteCommentText: "¿Estás seguro de que quieres eliminar este comentario?",
    precannedAnswers: "Respuestas predefinidas",
    assigneds: "Asignados",
    support_name: "Soporte GTAHub",
    supportCenter: "Centro de Soporte",
    needHelpStartHere: "¿Necesitas ayuda? Comienza aquí.",
    iNeedHelp: "Necesito ayuda",
    ctaGetSupport: "Solicitar soporte",
    iWantToReportSomeone: "Quiero reportar a alguien",
    yourTickets: "Tus tickets",
    hideWelcomeBanner: "Ocultar cabecera",
    showWelcomeBanner: "Mostrar bienvenida",
    welcome: "Bienvenido",
    to: "a",
    wereHereForYou: "Abre un ticket o sigue tus solicitudes.",
    simpleTicket: {
      title: "¿Qué necesitas?",
      placeholder: "Cuéntanos con qué necesitas ayuda, en al menos 20 caracteres",
      charsLeft: "Faltan {n} caracteres",
      searchPlaceholder: "Buscar categorías",
      noCategories: "Ninguna categoría coincide con tu búsqueda",
      chosen: "Categoría: {name}",
      loading: "Buscando categorías...",
      reportInstead: "Reportar a un jugador",
      decidedAs: "Lo tratamos como: {name}",
      decidedFallback: "Lo enviaremos a: {name}",
      notThis: "No es esto",
      pickCategory: "Elige la categoría",
      thinking: "Buscando la mejor categoría…",
    },
    simpleReport: {
      title: "Reportar a un jugador",
      accusedHelp: "Nombre_Apellido o #HASH",
      whatHappened: "¿Qué pasó?",
      detected: "Parece un reporte contra un jugador.",
      notAReport: "No es un reporte",
      descriptionPlaceholder: "Cuéntanos qué hizo el jugador, dónde y cómo, en al menos 20 caracteres",
      charsLeft: "Faltan {n} caracteres",
      categoryLoading: "Buscando categorías...",
      searchPlaceholder: "Buscar categorías de reporte",
      noCategories: "Ninguna categoría coincide con tu búsqueda.",
      evidence: "Evidencia",
      evidenceOptional: "Evidencia (opcional)",
      evidenceHelp: "Pega los enlaces a tus imágenes o videos (por ejemplo desde https://gofile.io/).",
      when: "Cuándo",
      now: "Ahora mismo",
      changeDate: "Cambiar fecha",
      useNow: "Usar la hora actual",
      moreDetails: "Más detalles",
      lessDetails: "Menos detalles",
      moreDetailsHint: "Todo es opcional.",
      juryInfo: "Tu reporte puede resolverse por un jurado de la comunidad",
      consent: "He leído las normas y acepto que un reporte falso o de mala fe puede acarrear sanciones",
      consentRead: "Leer las normas",
      submit: "Enviar reporte",
      errorCategory: "Elige una categoría de la lista",
      errorDescription: "Describe lo que pasó en al menos {min} caracteres",
      errorEvidence: "Añade al menos un enlace a tu evidencia",
      errorConsent: "Debes aceptar las normas para enviar el reporte",
      errorNoGroup: "Las categorías de reporte no están disponibles ahora mismo",
      errorGeneric: "No se pudo enviar el reporte. Inténtalo de nuevo.",
      decidedAs: "Lo tratamos como: {name}",
      decidedFallback: "Lo enviaremos a: {name}",
      notThis: "No es esto",
      pickCategory: "Elige la categoría",
      chosen: "Categoría: {name}",
    },
    categorySelection: {
      selectGroup: "¿Con qué necesitas ayuda?",
      selectCategory: "Selecciona una categoría",
      back: "Volver",
      close: "Cerrar",
      describeTitle: "Describe tu problema",
      describePlaceholder: "Cuéntanos qué pasó en pocas palabras, p. ej. \"mi coche desapareció del garaje\"",
      describeHint: "Te sugeriremos la categoría adecuada mientras escribes.",
      suggestionsTitle: "Categorías sugeridas",
      suggestionsLoading: "Buscando categorías...",
      noSuggestions: "Aún no hay sugerencias. Sigue describiendo tu problema o elige la categoría manualmente.",
      chooseManually: "Elegir la categoría manualmente",
      describeInstead: "Prefiero describir mi problema",
      searchPlaceholder: "Buscar categorías...",
      noSearchResults: "Ninguna categoría coincide con tu búsqueda."
    },
    categorySuggestion: {
      badge: "Categoría sugerida",
      move: "Mover",
      moveTitle: "Mover este ticket a la categoría sugerida",
      moveFailed: "No se pudo mover el ticket."
    },
    socketDisconnected:
      "Te has desconectado del servidor. Por favor, revisa tu conexión a internet y refresca la página.",

    requestTimeout: "La solicitud ha tardado demasiado. Revisa tu conexión e inténtalo de nuevo.",
    dashboardStats: {
      tickets: { total: "Tickets", unassigned: "Tickets sin asignar" },
      reports: {
        total: "Reportes",
        unassigned: "Reportes sin asignar",
        openUnassigned: "Reportes abiertos sin asignar",
        olderThan30d: "Reportes abiertos de más de 30 días",
        medianFirstResponseHours7d: "Reportes: mediana de primera respuesta (7d)",
      },
      support: { medianFirstResponseHours7d: "Soporte: mediana de primera respuesta (7d)" },
      hoursUnit: "h",
      noData: "Sin datos",
    },

    authCallbackLoading: "Iniciando sesión...",
    authCallbackFailed: "No pudimos iniciar tu sesión. Te llevamos de nuevo a la página de inicio de sesión...",
    authCallbackGiveUp: "No pudimos iniciar tu sesión. Recarga la página para intentarlo de nuevo.",
    authCallbackStateMismatch: "Este enlace de inicio de sesión no es válido para esta sesión.",

    socketConnectionLost: "Conexión perdida. Por favor, actualiza la página.",
    socketSessionExpired: "La sesión puede haber expirado. Actualiza la página para iniciar sesión de nuevo.",
    socketDisconnectedBanner: "Desconectado. La lista se actualizará cada minuto hasta reconectar.",
    socketReconnecting: "Reconectando… este reporte se actualizará cuando vuelva la conexión.",

    // reports
    create_new_report_description: "Elige una categoría para crear un reporte.",
    write_your_message: "Escribe tu mensaje...",
    latest_comment: "Comentario más reciente",
    oldest_comment: "Comentario más antiguo",
    newest: "Ticket más reciente",
    oldest: "Ticket más antiguo",
    staff: "Prioridad de staff",
    staff_latest: "Prioridad de staff (más reciente)",

    title: {
      admin_panel: "Panel de administración",
      suport_panel: "Soporte",
    },

    you_have: "Tienes",

    ticket: {
      title: "Título",
      category: "Categoría",
      status: "Estado",
      responder: "Emisor",
      date: "Fecha",
      assign: "Asignar",
      escalate: "Escalar",
      escalateTo: "Cambiar a grupo / categoría",
      escalateNone: "No hay otros grupos disponibles",
      create_new: "Crea un nuevo ticket",
      is_closed: "Este ticket se encuentra cerrado",
      take_review: "Revise de nuevo por favor.",
      write_message: "Escribiendo...",
      you_took_review: "Revisaste esta respuesta",
      review_of_your_answer: "Revisión de su respuesta",
      title_of_ticket: "Título del ticket",
      content_of_ticket: "Contenido del ticket",
      your_opened_tickets: "Tus tickets abiertos",
      opened_tickets: "Tickets abierto",
      click_on_ticket: "Click en el ticket para abrirlo",
      send: "Enviar",
      no_tickets:
        "No hay ningún ticket. Prueba cambiando filtros o crea uno si tienes un problema.",
      take: "Tomar ticket",
      lastReply: "Última respuesta",
      ago: "atrás",
      unread: "sin leer",
      unread_one: "sin leer",
      noAnswer: "Sin respuesta",
      takenBy: "Tomado por",
      createdBy: "Creado por",
      attachment: "archivo adjunto",
      attachments: "archivos adjuntos",
      openAllInTabs: "Abrir todos en pestañas",
      staffPriority: "Prioridad de Staff",
      andNMore: "y {n} más",
      assignNone: "No hay asignados disponibles",
      closed: "Ticket cerrado",
      comments_count: "Comentarios",
      context: "Contexto del Ticket",
      created_at: "Creado",
      details: "Detalles del Ticket",
      history: "Historial",
      id: "ID del Ticket",
      id_copied: "ID del ticket copiado al portapapeles",
      last_comment: "Último Comentario",
      last_updated: "Última Actualización",
      reopened: "Ticket reabierto",
      selectTicket: "Selecciona un ticket para ver detalles",
      taken: "Ticket tomado",
      unassigned: "Ticket desasignado",
      unknown_type: "Tipo de ticket desconocido",
      view: {
        label: "Vista",
        user: "Vista de usuario",
        workspace: "Espacio de trabajo"
      },
      description: "Descripción",
      reporter: "Reportante",
      commentAndClose: "Comentar y cerrar",
      reported_user: "Usuario Reportado",
      created: "Creado"
    },

    filters: "Filtros",
    copyLink: "Copiar enlace",
    takeTicket: "Tomar ticket",
    takeToReply: "Toma el ticket para poder responder.",
    editingInComposer: "Editando en el compositor. Usa el botón enviar principal.",
    sendStaffOnly: "Enviar (solo staff)",
    assistant: {
      hide: "Ocultar",
      title: "Asistente del Staff",
      close: "Cerrar",
      conversations: "Conversaciones",
      newChat: "Nueva",
      placeholder: "Pregunta por resumen, próximos pasos, resultados..."
    },

    support: {
      opened_tickets: "Tickets abiertos",
      your_assignments: "Tickets asignados",
      no_assigned_tickets: "No tienes ningún ticket asignado",
      no_tickets: "No hay tickets en este momento a la espera de una respuesta",
      responder: "Asignado a",
    },

    report: {
      accused: "Acusado",
      reporter: "Reportante",
      accused_help: "Nombre_Apellido o #HASH",
      partners: "Cómplices",
      date_of_event: "Fecha y hora del suceso",
      date_of_event_info: "Selecciona según tu hora local, se convertirá automáticamente a HORA HUB del servidor.",
      date_of_event_hub: "Fecha y hora del suceso (HUB)",
      no_reports: "No creaste ningún reporte ni tampoco te han reportado. Nada que mostrar.",
      now: "Ahora",
      addPartner: "Añadir",
      removePartner: "Quitar",
      partner: "Cómplice",
      reason: "Razón (reglas inclumplidas)",
      broken_rules: "Reglas incumplidas",
      description: "Descripción de los hechos",
      take: "Tomar reporte",
      secondaryRules: "Reglas secundarias",
      secondary_rules: "Reglas secundarias",
      secondaryRulesInfo: "No es necesario agregar reglas en este menú. Aquí puedes seleccionar alguna regla que no esté en el menú de arriba, ten en cuenta que obtendrás una sanción si agregas reglas que no se hayan incumplido en el reporte.",
      in_fraganti_label: "Está ocurriendo ahora mismo",
      in_fraganti_warning: "Sólo activa esta opción si realmente el reporte está sucediendo ahora mismo. Reportes con esta opción que sean mentira podrán acarrear sanciones.",
      invalid: "Inválido",
      valid: "Válido",
      resolutionTitle: "Resolución del reporte.",
      resolutionInfo: "Selecciona si el reporte fue válido (el reportante tuvo razón y los involucrados obtendrán sus sanciones) o inválido.",
      request_more_responses: "Requerir más intervenciones",
      // Enhanced reporting fields
      type: "Tipo de Reporte",
      type_normal: "Reporte Normal",
      type_normal_desc: "El staff revisará y tomará la decisión final",
      type_jury: "Reporte con Jurado",
      type_jury_desc: "Un jurado de la comunidad votará la validez antes de la revisión del staff",
      suggested_penalties: "Penalizaciones Sugeridas",
      suggested_penalties_help: "Selecciona los bloques de penalización que crees que deberían aplicarse. Estas son sugerencias para la revisión final.",
      accused_required: "Debes especificar al jugador acusado",
      description_required: "Debes proporcionar una descripción de los hechos",

      // Notificaciones en vivo
      juryAssigned: "Jurado de {count} miembros asignado",
      juryValid: "válido",
      juryInvalid: "inválido",
      juryVotingComplete: "Votación del jurado completa: reporte {result}",
      juryVotingExpired: "Expiró el plazo de votación del jurado",
      staffAssigned: "Staff {name} asignado",
      deadlineWarning: "Aviso: el plazo de {type} vence en {hours} horas",
      deadline: {
        response: "Respuesta",
        conciliation: "Conciliación",
        jury: "Votación del jurado",
        postJury: "Elección post-jurado",
        staffVoting: "Votación de staff",
      },
      
      // Report Status
      close: "Cerrar Reporte",
      closed: "El reporte ha sido cerrado",
      accepted: "Reporte Aceptado",
      accepted_by_user: "Aceptado por el Usuario Reportado",
      acceptedByReported: "El usuario reportado ha aceptado el reporte",
      agreement_reached: "Acuerdo Alcanzado",
      agreementReached: "Acuerdo alcanzado",
      parties_agreed: "Las Partes Llegaron a un Acuerdo",
      accept_staff_review_note: "El usuario reportado aceptó el reporte de buena fe. El staff puede revisar y aplicar los bloques de penalización finales (con la reducción aplicada).",
      agreement_staff_review_note: "Ambas partes llegaron a un acuerdo durante la conciliación. El staff puede revisar y aplicar los bloques acordados o ajustarlos si es necesario.",
      resolve_type_accept_locked: "El tipo de resolución está fijado en Aceptar Culpa porque el usuario reportado aceptó el reporte",
      resolve_type_agreement_locked: "El tipo de resolución está fijado en Acuerdo porque ambas partes llegaron a un acuerdo",
      agreed_penalties: "Penalizaciones Acordadas",
      final_penalties: "Penalizaciones Finales",
      penalty_reduction: "Reducción de Penalización",
      related_reports: "Reportes Relacionados",
      conciliationExpired: "El período de conciliación ha expirado",
      disputedStartConciliation: "El reporte ha sido disputado. Comenzó la conciliación",
      responseDeadlineExpired: "Expiró el plazo de respuesta. Disputado automáticamente",
      newTradeProposal: "Nueva propuesta de intercambio de penalización",
      counterProposalReceived: "Contrapropuesta recibida",
      tradeAccepted: "Propuesta de intercambio aceptada. Acuerdo alcanzado.",
      tradeRejected: "Propuesta de intercambio rechazada",
      statusUpdated: "Estado del reporte actualizado",

      status: "Estado del Reporte",
      normal: "Normal",
      jury_based: "Con Jurado",

      // Deadlines
      response_deadline: "Fecha Límite de Respuesta",
      conciliation_deadline: "Fecha Límite de Conciliación",
      jury_voting_deadline: "Fecha Límite de Votación",
      post_jury_choice_deadline: "Fecha Límite de Elección de la Parte",
      staff_voting_deadline: "Fecha Límite de Votación de Staff",
      deadline_expired: "Expirado",
      days: "días",
      minutes: "minutos",

      // Accept/Dispute
      your_response: "Tu Respuesta",
      response_instructions: "Has sido reportado. Por favor revisa los detalles del reporte y elige cómo responder. Puedes aceptar el reporte y recibir una penalización reducida, o disputarlo y entrar en fase de conciliación.",
      accept_report: "Aceptar Reporte",
      accept_description: "Al aceptar, reconoces la violación. Recibirás una reducción de penalización como incentivo por asumir la responsabilidad.",
      penalty_reduction_info: "Recibirás una reducción del {percent}% en la penalización.",
      accept: "Aceptar",
      dispute_report: "Disputar Reporte",
      dispute_description: "Al disputar, entrarás en una fase de conciliación donde podrás negociar con el reportante. Si no se alcanza un acuerdo, el reporte puede ir a revisión del jurado o del staff.",
      dispute: "Disputar",
      already_accepted: "Ya has aceptado este reporte. La reducción de penalización ha sido aplicada.",
      already_disputed: "Has disputado este reporte. Por favor revisa la fase de conciliación para actualizaciones.",
      confirm_accept_title: "Confirmar Aceptación",
      confirm_accept_text: "¿Estás seguro de que quieres aceptar este reporte? Esta acción no se puede deshacer.",
      accepted_success: "Reporte aceptado exitosamente. La reducción de penalización ha sido aplicada.",
      error_accepting: "Ocurrió un error al aceptar el reporte.",
      confirm_dispute_title: "Confirmar Disputa",
      confirm_dispute_text: "¿Estás seguro de que quieres disputar este reporte? Esto iniciará la fase de conciliación.",
      disputed_success: "Reporte disputado exitosamente.",
      conciliation_started: "La fase de conciliación ha comenzado. Ahora puedes negociar con el reportante.",
      error_disputing: "Ocurrió un error al disputar el reporte.",

      // Conciliation
      conciliation: "Conciliación",
      conciliation_instructions: "Conciliación: negocia la sanción con la otra parte intercambiando propuestas de bloques de penalización. El chat del ticket está cerrado en esta fase, así que todo se hace con propuestas: haces una y la otra parte la acepta, la rechaza o responde con una contraoferta. Un acuerdo pasa al staff para la decisión final.",
      messages: "Mensajes",
      no_messages: "No hay mensajes aún. Inicia la conversación para negociar.",
      type_message: "Escribe tu mensaje...",
      send_message: "Enviar Mensaje",
      error_sending_message: "Ocurrió un error al enviar el mensaje.",

      // Coach spotlight (onboarding party + jury)
      coach: {
        step_of: "Paso {current} de {total}",
        skip: "Omitir",
        continue: "Continuar",
        finish: "Entendido",
        replay: "Cómo funciona Overwatch",
        party: {
          status_title: "Progreso del reporte",
          status_body: "Esta barra muestra en qué punto está el reporte en el flujo de Overwatch: respuesta, conciliación, jurado o revisión de staff.",
          deadlines_title: "Plazos",
          deadlines_body: "Cada fase tiene un temporizador. Actúa antes de que expire o el sistema puede avanzar el reporte automáticamente.",
          accept_dispute_title: "Tu respuesta",
          accept_dispute_body: "Si te reportaron, acepta para una penalización reducida o disputa para abrir conciliación con la otra parte.",
          conciliation_title: "Conciliación",
          conciliation_body: "Negocia bloques de penalización con la otra parte. Un acuerdo sigue pasando por staff para la decisión final.",
          chat_title: "Chat",
          chat_body: "Usa el chat del ticket para compartir pruebas. Está cerrado durante la conciliación (negocia con propuestas) y limitado a pocos mensajes durante la fase de jurado.",
        },
        jury: {
          instructions_title: "Revisión del jurado",
          instructions_body: "Lee el caso con cuidado. Debes decidir si el reporte es válido según la evidencia, no aplicar sanciones tú mismo.",
          vote_title: "Emite tu voto",
          vote_body: "Vota Válido si se rompieron las reglas, o Inválido si el reporte no tiene mérito. Solo puedes votar una vez.",
          chat_title: "Sin chat para el jurado",
          chat_body: "El jurado no puede escribir en el chat del caso ni ser contactado por las partes. Basa tu voto solo en las pruebas mostradas.",
        },
      },

      // Staff Review
      review: "Revisión del Staff",
      details: "Detalles del Reporte",
      close_report: "Cerrar Reporte",
      resolve_type: "Tipo de Resolución",
      resolve: {
        unresolved: "Sin Resolver",
        agreement: "Acuerdo",
        accept_guilt: "Culpa Aceptada",
        valid: "Válido (Reporte Confirmado)",
        invalid: "Inválido (Reporte Rechazado)"
      },
      error_closing: "Ocurrió un error al cerrar el reporte.",
      post_jury: {
        title: "Veredicto del jurado: tu elección",
        hint_guilty: "El jurado consideró el reporte válido (culpable). Puedes aceptar la sanción o solicitar revisión de staff.",
        hint_innocent: "El jurado desestimó tu reporte porque considera inocente al sujeto. Acepta su decisión para cerrar el caso, o escala al staff si no estás de acuerdo.",
        accept_sanction: "Aceptar mi sanción (100%)",
        accept_innocent: "Aceptar decisión del jurado y cerrar caso",
        appeal_staff: "Escalar al staff",
        hint_no_verdict: "El jurado no llegó a un veredicto (pocos votos o empate). Sin veredicto no hay sanción; cualquiera de las partes puede escalar el caso al staff.",
        accept_no_verdict: "Retirar el reporte sin sanción",
        appeal_confirm_title: "¿Escalar al staff?",
        appeal_confirm_guilty: "El staff votará tu caso. Si confirma el veredicto, tu sanción se multiplica por {m}. Si lo rechaza, no hay sanción. No se puede deshacer.",
        appeal_confirm_innocent: "El staff votará el caso. Si considera válido el reporte, la sanción del acusado se multiplica por {m}. No se puede deshacer.",
        appeal_confirm_no_verdict: "El staff votará el caso. Si considera válido el reporte, se aplica la sanción normal. No se puede deshacer.",
        accept_confirm_title: "¿Aceptar la decisión del jurado?",
        accept_confirm_guilty: "El staff confirmará el veredicto y aplicará la sanción completa. Después no podrás escalarlo.",
        accept_confirm_innocent: "Cuando el staff lo confirme, el caso se cierra sin sanción. Después no podrás escalarlo.",
        accept_confirm_no_verdict: "Cuando el staff lo confirme, el reporte se descarta sin sanción. Después no podrás escalarlo."
      },
      staff_vote: {
        title: "Voto del staff",
        progress: "Aceptar {accept} · Rechazar {reject} · Necesitan {needed} de {pool}",
        progress_majority: "Aceptar {accept} · Rechazar {reject} · Mayoría de los votos emitidos, mínimo {needed} votos",
        assigned: "Revisores asignados",
        accept: "Aceptar / Condenar",
        reject: "Rechazar / Inválido",
        already_voted: "Ya votaste: {vote}",
        threshold_reached: "Umbral de votos alcanzado. Finaliza las sanciones abajo.",
        mock_all_accept: "DEV: Simular staff → Aceptar",
        mock_all_reject: "DEV: Simular staff → Rechazar",
        mock_votes_title: "¿Simular votos de staff? (DEV)",
        mock_votes_success: "Se simularon {count} voto(s) restantes de staff.",
        mock_votes_error: "No se pudieron simular los votos de staff.",
        vote_word_accept: "aceptar",
        vote_word_reject: "rechazar",
        confirm_title: "¿Emitir tu voto?",
        confirm_accept_text: "Tu voto no se puede cambiar. Si la mayoría acepta, se aplica la sanción con cantidades ×{m}.",
        confirm_reject_text: "Tu voto no se puede cambiar. Si la mayoría rechaza, no se aplica ninguna sanción."
      },
      settlement_staff_takeover: "Los jugadores llegaron a un acuerdo. Puedes agregar, quitar o editar bloques. Tu decisión es final.",
      settlement_original_agreement: "Acuerdo original de los jugadores",
      settlement_edit_hint: "Edita los bloques finales abajo. Al cerrar se aplica tu selección.",
      review_load_failed: "No se pudieron cargar los datos del reporte.",
      // ENG-1758: progreso unificado, siguiente paso, resultado y consecuencias
      progress: {
        title: "Progreso",
        step: {
          filed: "Creado",
          response: "Respuesta",
          conciliation: "Conciliación",
          jury: "Jurado",
          verdict: "Veredicto",
          staff: "Staff",
          closed: "Cerrado"
        },
        state: {
          done: "Hecho",
          current: "Ahora",
          future: "Después",
          skipped: "Omitido"
        }
      },
      countdown: {
        expired: "plazo vencido, procesando",
        in_minutes: "en {m} min",
        in_hours_minutes: "en {h} h {m} min",
        in_days_hours: "en {d} d {h} h",
        until: "hasta el {date}"
      },
      deadline_kind: {
        response: "Respuesta del acusado",
        conciliation: "Fin de la negociación",
        proposal: "Respuesta a la propuesta actual",
        jurySelection: "Formación del jurado",
        juryVoting: "Votación del jurado",
        postJury: "Aceptar o escalar el veredicto",
        staffVoting: "Votación del staff",
        agreementClose: "Cierre automático con el acuerdo"
      },
      deadline_owner: {
        accused: "Esperando a: el acusado",
        parties: "Esperando a: ambas partes",
        reporter: "Esperando a: quien reportó",
        jurors: "Esperando a: el jurado",
        staff: "Esperando a: el staff",
        system: "Esperando a: que se apunten jurados",
        proposalResponder: "Esperando a: quien recibió la propuesta",
        you: "Esperando a: ti"
      },
      next: {
        title: "Qué pasa ahora",
        can_label: "Qué puedes hacer",
        deadline_label: "Plazo",
        no_deadline: "Esta fase no tiene plazo automático.",
        created: {
          any: { now: "El reporte se creó y se está preparando.", can: "Todavía no tienes que hacer nada. Te avisaremos cuando empiece la siguiente fase." }
        },
        pending_response: {
          accused: { now: "Te han reportado. Debes aceptar o disputar el reporte antes del plazo.", can: "Acepta para recibir una sanción reducida, o disputa para negociar con quien te reportó. Si no haces nada, el reporte se disputa automáticamente." },
          reporter: { now: "Esperando a que el acusado acepte o dispute el reporte.", can: "No tienes que hacer nada. Si no responde a tiempo, el reporte se disputa automáticamente y pasa a conciliación." },
          staff: { now: "Esperando la respuesta del acusado.", can: "Todavía no hace falta ninguna acción." },
          any: { now: "Esperando la respuesta del acusado.", can: "No tienes que hacer nada ahora." }
        },
        accepted: {
          accused: { now: "Aceptaste el reporte. El staff aplicará la sanción reducida y lo cerrará.", can: "No tienes que hacer nada más. El resultado aparecerá aquí." },
          reporter: { now: "El acusado aceptó el reporte. El staff aplicará la sanción y lo cerrará.", can: "No tienes que hacer nada. El resultado aparecerá aquí." },
          staff: { now: "El acusado aceptó el reporte. La reducción ya está aplicada a los bloques propuestos.", can: "Revisa los bloques finales y cierra el reporte." },
          any: { now: "El acusado aceptó el reporte. El staff lo cerrará.", can: "No tienes que hacer nada ahora." }
        },
        disputed: {
          any: { now: "El reporte fue disputado y está empezando la conciliación.", can: "Espera un momento: el panel de negociación se abre solo." }
        },
        conciliation: {
          reporter: { now: "Conciliación: ambas partes negocian la sanción intercambiando propuestas de bloques de penalización. El chat está cerrado en esta fase.", can: "Haz, acepta o rechaza una propuesta, o responde con una contraoferta, en el panel de abajo. Cada propuesta tiene su propio plazo de respuesta. Si no hay acuerdo antes del plazo, el caso pasa a un jurado (reportes con jurado) o al staff." },
          accused: { now: "Conciliación: ambas partes negocian la sanción intercambiando propuestas de bloques de penalización. El chat está cerrado en esta fase.", can: "Haz, acepta o rechaza una propuesta, o responde con una contraoferta, en el panel de abajo. Cada propuesta tiene su propio plazo de respuesta. Si no hay acuerdo antes del plazo, el caso pasa a un jurado (reportes con jurado) o al staff." },
          staff: { now: "Las partes están negociando la sanción.", can: "No hace falta ninguna acción. Si hay acuerdo, te llegará para revisión." },
          any: { now: "Las partes están negociando la sanción.", can: "No tienes que hacer nada ahora." }
        },
        agreement_reached: {
          reporter: { now: "Se llegó a un acuerdo. El staff lo confirmará y cerrará el reporte. Si el staff no actúa, se cierra automáticamente con la sanción acordada al vencer el plazo.", can: "No tienes que hacer nada más." },
          accused: { now: "Se llegó a un acuerdo. El staff lo confirmará y cerrará el reporte. Si el staff no actúa, se cierra automáticamente con la sanción acordada al vencer el plazo.", can: "No tienes que hacer nada más." },
          staff: { now: "Las partes llegaron a un acuerdo. Si nadie lo cierra, se cierra automáticamente con la sanción acordada al vencer el plazo.", can: "Confirma o ajusta los bloques acordados y cierra el reporte." },
          any: { now: "Las partes llegaron a un acuerdo. El staff cerrará el reporte.", can: "No tienes que hacer nada ahora." }
        },
        conciliation_expired: {
          any: { now: "La conciliación terminó sin acuerdo. El caso está pasando a la siguiente fase.", can: "No tienes que hacer nada. Esta pantalla se actualiza sola." }
        },
        jury_phase: {
          juror: { now: "Te uniste a este jurado. La votación empieza en cuanto se llenen todos los puestos.", can: "Lee el caso mientras esperas." },
          staff: { now: "Se están buscando jugadores para el jurado.", can: "Si la selección se atasca, reinténtala desde el aviso de arriba. Si no se forma jurado a tiempo, el caso pasa al staff." },
          any: { now: "Se está formando un jurado de jugadores para revisar el caso.", can: "No tienes que hacer nada. Si no se forma jurado a tiempo, el caso pasa al staff." }
        },
        jury_voting: {
          juror: { now: "Decide si el reporte es válido basándote solo en las pruebas.", can: "Emite tu voto abajo antes del plazo. Tu voto es anónimo y no se puede cambiar." },
          staff: { now: "El jurado está votando.", can: "No hace falta ninguna acción. Revisarás el caso tras el veredicto si una parte lo escala." },
          any: { now: "Un jurado anónimo de jugadores está votando si el reporte es válido.", can: "No tienes que hacer nada. No se puede contactar al jurado." }
        },
        jury_valid: {
          chooser: { now: "El jurado consideró válido el reporte.", can: "Acepta la sanción (penalización completa) o escala al staff (la penalización se multiplica por 1,5 si el staff la confirma). Si no eliges antes del plazo, la sanción se acepta automáticamente." },
          waiting: { now: "El jurado consideró válido el reporte. El acusado puede aceptar la sanción o escalar al staff.", can: "No tienes que hacer nada. Si no elige a tiempo, la sanción se acepta automáticamente." },
          juror: { now: "Votación terminada: el reporte se consideró válido.", can: "No tienes que hacer nada más. Gracias por participar." },
          staff: { now: "Veredicto del jurado: válido. Esperando la elección del acusado.", can: "Todavía no hace falta ninguna acción." },
          any: { now: "El jurado consideró válido el reporte.", can: "No tienes que hacer nada ahora." }
        },
        jury_invalid: {
          chooser: { now: "El jurado desestimó el reporte.", can: "Acepta la decisión (el caso se cierra sin sanción) o escala al staff. Si no eliges antes del plazo, la decisión se acepta automáticamente." },
          waiting: { now: "El jurado desestimó el reporte. Quien reportó puede aceptar la decisión o escalar al staff.", can: "No tienes que hacer nada. Si no elige a tiempo, el caso se cierra sin sanción." },
          juror: { now: "Votación terminada: el reporte se desestimó.", can: "No tienes que hacer nada más. Gracias por participar." },
          staff: { now: "Veredicto del jurado: inválido. Esperando la elección de quien reportó.", can: "Todavía no hace falta ninguna acción." },
          any: { now: "El jurado desestimó el reporte.", can: "No tienes que hacer nada ahora." }
        },
        jury_no_verdict: {
          chooser: { now: "El jurado no llegó a un veredicto (empate o pocos votos). Sin veredicto no hay sanción.", can: "Cualquiera de las partes puede escalar el caso al staff antes del plazo. Si nadie lo hace, el caso se cierra sin sanción." },
          waiting: { now: "El jurado no llegó a un veredicto.", can: "No tienes que hacer nada ahora." },
          juror: { now: "Votación terminada sin veredicto.", can: "No tienes que hacer nada más. Gracias por participar." },
          staff: { now: "El jurado no llegó a un veredicto. Esperando a que las partes escalen o dejen que se cierre.", can: "Todavía no hace falta ninguna acción." },
          any: { now: "El jurado no llegó a un veredicto.", can: "No tienes que hacer nada ahora." }
        },
        staff_review: {
          staff: { now: "Este reporte necesita una decisión del staff.", can: "Elige los bloques de penalización finales y la resolución, y cierra el reporte." },
          any: { now: "El staff está revisando el caso y decidirá la sanción final.", can: "No tienes que hacer nada. La revisión del staff no tiene plazo automático; te avisaremos del resultado." }
        },
        staff_voting: {
          staff: { now: "Varios miembros del staff votan este caso. Decide la mayoría de los votos emitidos.", can: "Vota Aceptar o Rechazar abajo antes del plazo." },
          any: { now: "Varios miembros del staff están votando el caso. Decide la mayoría de los votos emitidos.", can: "No tienes que hacer nada. Te avisaremos del resultado." }
        },
        closed: {
          any: { now: "El reporte está cerrado.", can: "Mira el resultado abajo." }
        }
      },
      outcome: {
        title: "Resultado",
        resolution: "Resolución",
        penalty: "Sanción aplicada",
        no_penalty: "No se aplicó ninguna sanción.",
        penalty_hidden: "Los detalles de la sanción solo los ven las partes y el staff.",
        multiplier: "Escala de la sanción ×{m}",
        score: "Tu cambio de reputación",
        score_none: "Tu reputación no cambió.",
        no_verdict: "El jurado no llegó a un veredicto."
      },
      accept_consequence: "Aceptar es definitivo: reconoces la infracción, la sanción se reduce un {percent}% y la aplica el staff. Después no podrás disputarlo.",
      accept_no_penalty_proposed: "Este reporte no propone sanción: la decidirá el staff. Tu reducción del {percent}% se aplica igualmente.",
      proposed_penalty_by_staff: "La sanción la decidirá el staff.",
      dispute_consequence_jury: "Disputar abre una negociación con quien te reportó. Si no hay acuerdo, el caso pasa a un jurado de jugadores.",
      dispute_consequence_staff: "Disputar abre una negociación con quien te reportó. Si no hay acuerdo, el caso pasa al staff.",
      close_confirm_title: "¿Cerrar el reporte?",
      close_confirm_text: "Resolución: {resolution}. {penalty} Es definitivo: se aplican las sanciones y se avisa a las partes.",
      close_preview_none: "No se aplicará ninguna sanción.",
      close_preview_blocks: "Se aplicarán {count} bloque(s) de penalización.",
      close_preview_blocks_scaled: "Se aplicarán {count} bloque(s) de penalización, cantidades ×{m}.",
      // Protected-user approval gate
      pendingApproval: "Esperando aprobación de staff",
      protectedTargetExplanation: "Este reporte apunta a un usuario protegido y debe ser revisado por staff antes de que el acusado sea notificado.",
      approve: "Aprobar y notificar",
      reject: "Rechazar",
      rejected: "Rechazado por staff",
      rejectReason: "Motivo (opcional)",
      pendingApprovalFilter: "Pendientes de aprobación",
      rejectedFilter: "Rechazados"
    },

    // Report Status (flat keys for $t calls)
    reportStatus: {
      created: "Creado",
      pending_response: "Pendiente de Respuesta",
      accepted: "Aceptado",
      disputed: "Disputado",
      conciliation: "En Conciliación",
      agreement_reached: "Acuerdo Alcanzado",
      conciliation_expired: "Conciliación Expirada",
      jury_phase: "Fase de Jurado",
      jury_voting: "Votación del Jurado",
      jury_valid: "Jurado: Válido",
      jury_invalid: "Jurado: Inválido",
      staff_review: "Revisión de Staff",
      jury_no_verdict: "Jurado: Sin veredicto",
      staff_voting: "Votación de Staff",
      closed: "Cerrado"
    },

    // Report Actions
    reportActions: {
      accept: "Aceptar Reporte",
      accept_confirm: "¿Estás seguro de que quieres aceptar este reporte? Recibirás una reducción de penalización.",
      accept_info: "Al aceptar, reconoces la violación y recibes una reducción del {reduction}% en la penalización.",
      dispute: "Disputar Reporte",
      dispute_confirm: "¿Estás seguro de que quieres disputar este reporte? Esto iniciará la fase de conciliación.",
      dispute_info: "Disputar iniciará un período de conciliación de {hours} horas donde podrás negociar con el reportante.",
      respond: "Responder",
      view_details: "Ver Detalles",
      close_report: "Cerrar Reporte",
      apply_penalties: "Aplicar Penalizaciones"
    },

    // Conciliation
    conciliation: {
      title: "Conciliación",
      description: "Negocia con la otra parte para llegar a un acuerdo.",
      time_remaining: "Tiempo Restante",
      hours: "horas",
      minutes: "minutos",
      send_message: "Enviar Mensaje",
      message_placeholder: "Escribe tu mensaje...",
      no_messages: "No hay mensajes aún. Inicia la conversación.",
      chat_blocked: "El chat está deshabilitado durante la fase de conciliación.",
      reject_confirm_jury: "Rechazar termina la negociación en el acto: el caso pasa a un jurado de jugadores. No se puede deshacer.",
      reject_confirm_staff: "Rechazar termina la negociación en el acto: el caso pasa a revisión del staff. No se puede deshacer.",
      reject_confirm_normal: "La propuesta se rechaza. La negociación sigue hasta el plazo de conciliación; si no hay acuerdo, el caso pasa al staff.",
      proposal_timer_you: "Debes responder a esta propuesta",
      proposal_timer_them: "La otra parte debe responder a esta propuesta",
      proposal_timer_hint: "Una propuesta sin respuesta a tiempo se rechaza automáticamente.",

      trading: {
        title: "Negociación de Bloques de Penalización",
        current_proposal: "Propuesta Actual",
        original_blocks: "Bloques Originales",
        proposed_blocks: "Bloques Propuestos",
        propose_new: "Proponer Nuevo Intercambio",
        accept_proposal: "Aceptar Propuesta",
        reject_proposal: "Rechazar Propuesta",
        counter_proposal: "Contraproponer",
        no_proposals: "No hay propuestas activas. Puedes proponer un intercambio de penalización.",
        proposal_accepted: "Propuesta Aceptada",
        proposal_rejected: "Propuesta Rechazada",
        waiting_response: "Esperando que la otra parte responda...",
        your_turn: "Tu turno de responder",
        their_turn: "Esperando a la otra parte",
        // NEW: Additional turn-based trading keys
        history: "Historial de Negociaciones",
        propose_help: "Selecciona los bloques de penalización que quieres proponer. La otra parte deberá aceptar, rechazar o contraproponer.",
        counter_help: "Selecciona bloques de penalización diferentes como tu contrapropuesta. La otra parte responderá a tu nueva oferta.",
        message_optional: "Mensaje (opcional)",
        message_placeholder: "Explica tu propuesta...",
        submit_proposal: "Enviar Propuesta",
        submit_counter: "Enviar Contrapropuesta",
        status_pending: "Pendiente",
        status_accepted: "Aceptada",
        status_rejected: "Rechazada",
        status_countered: "Contrapropuesta",
        status_expired: "Expirada",
        // Error messages
        error_not_your_turn: "No es tu turno de responder",
        error_must_respond: "Debes aceptar, rechazar o contraproponer la propuesta actual primero",
        error_waiting: "Esperando que la otra parte responda a tu propuesta",
        original_proposal: "Propuesta Original",
        original_proposal_description: "Esta es la propuesta de penalización inicial del reportante. Puedes enviar una contrapropuesta abajo.",
        propose_counter: "Proponer una contrapropuesta",
        proposed_by: "Propuesto por",
      },

      agreement: {
        title: "Acuerdo Alcanzado",
        description: "Ambas partes han acordado las siguientes penalizaciones:",
        agreed_blocks: "Bloques de Penalización Acordados",
        proceed_to_review: "Esto ahora irá a revisión del staff."
      },

      expired: {
        title: "Conciliación Expirada",
        description: "El período de conciliación ha terminado sin un acuerdo.",
        next_step_jury: "Este reporte ahora irá a votación del jurado.",
        next_step_staff: "Este reporte ahora irá a revisión del staff."
      }
    },

    // Jury System
    jury: {
      title: "Revisión del Jurado",
      enter_as_jury: "Entrar como Jurado",
      no_available_tickets: "No se encontraron tickets de jurado disponibles en este momento.",
      available_list_title: "Casos de jurado abiertos",
      available_list_empty: "No hay casos de jurado abiertos en este momento.",
      available_list_seats: "{current} / {max} jurados",
      available_list_join: "Unirse",
      available_list_close: "Cerrar",
      available_list_phase_recruiting: "Buscando jurados",
      available_list_phase_voting: "Votación en curso",
      join: {
        title: "Unirse como Miembro del Jurado",
        description: "Este reporte está buscando miembros del jurado de la comunidad para ayudar a revisar el caso. Puedes unirte como miembro del jurado si no estás involucrado en este reporte.",
        button: "Unirse como Miembro del Jurado",
        confirm_title: "¿Unirse como Miembro del Jurado?",
        confirm_text: "¿Estás seguro de que quieres unirte como miembro del jurado para este caso? Podrás revisar el caso anonimizado y votar sobre su validez.",
        success_title: "Listo",
        success_text: "Te has unido exitosamente como miembro del jurado. Podrás votar una vez que comience la fase de votación del jurado.",
        error: "Error al unirse como miembro del jurado",
        cannot_join: "No puedes unirte a este caso.",
        already_member: "Ya eres miembro del jurado para este caso",
        not_recruiting: "Este caso ya no busca jurados.",
        jury_full: "Este jurado ya está completo.",
        seat_taken: "Se acaba de ocupar el último puesto o la votación ya empezó.",
        recently_served: "Formaste parte de un jurado hace poco. Espera unos días antes de unirte a otro.",
        not_eligible_case: "No puedes juzgar este caso (tienes relación con alguna de las partes o una sanción activa).",
        training_required: "Completa el entrenamiento de Overwatch para unirte a jurados.",
        cannot_join_reporter: "No puedes unirte como jurado porque eres el reportero",
        cannot_join_reported: "No puedes unirte como jurado porque eres el usuario reportado",
        cannot_join_staff: "Los miembros del staff asignados a este ticket no pueden unirse como jurado",
        reputation_too_low: "Tu reputación es demasiado baja para unirte como miembro del jurado",
        max_active_duties: "Ya estás sirviendo en el número máximo de jurados activos",
        staff_excluded: "Los miembros del staff no pueden unirse como jurado",
        max_reached: "Se ha alcanzado el número máximo de jurados ({max})",
        current_count: "{current} de {max} miembros del jurado"
      },
      description: "Revisa el caso y emite tu voto.",
      case_details: "Detalles del Caso",
      evidence: "Evidencia",
      case_review: "Revisión del Caso por el Jurado",
      instructions: "Revisa toda la evidencia y los detalles cuidadosamente. Tu voto ayudará a determinar el resultado de este reporte. Vota 'Válido' si crees que se violaron las reglas, o 'Inválido' si el reporte carece de mérito.",
      no_chat_for_jurors: "El jurado no puede escribir en el chat del caso. Basa tu voto solo en las pruebas mostradas.",
      parties: "Partes Involucradas",
      anonymous_user: "Usuario Anónimo",
      view_evidence: "Ver Evidencia",
      status: "Estado del Jurado",
      votes: "Votos",

      voting: {
        title: "Emitir tu Voto",
        valid: "Votar Válido",
        valid_description: "El reporte es legítimo y se violaron las reglas.",
        invalid: "Votar Inválido",
        invalid_description: "El reporte no está justificado o carece de evidencia.",
        confirm: "Confirmar Voto",
        already_voted: "Ya has votado",
        your_vote: "Tu Voto",
        deadline: "Fecha Límite de Votación",
        votes_cast: "Votos Emitidos"
      },

      results: {
        title: "Resultados del Jurado",
        valid_votes: "Votos Válidos",
        invalid_votes: "Votos Inválidos",
        outcome: "Resultado",
        report_valid: "Reporte Confirmado",
        report_invalid: "Reporte Rechazado"
      },
      majority_decision: "Se alcanzó la mayoría",

      assignment: {
        title: "Asignar Jurado",
        select_members: "Seleccionar Miembros del Jurado",
        search_users: "Buscar usuarios...",
        selected: "Seleccionados",
        assign_button: "Asignar Jurado",
        selecting: "Seleccionando jurado",
        min_required: "Mínimo {count} miembros del jurado requeridos"
      },
      selecting: "Seleccionando jurado",
      selecting_help: "Buscando jurados elegibles. Esto puede tardar un momento.",
      retry: "Reintentar",
      selection_busy: "La selección del jurado ya está en curso",
      assignment_failed: "No se pudo asignar el jurado",

      // Additional jury keys
      valid: "Válido",
      invalid: "Inválido",
      valid_votes: "Votos Válidos",
      invalid_votes: "Votos Inválidos",
      majority_reached: "Mayoría Alcanzada",
      cast_vote: "Emitir tu Voto",
      submit_vote: "Enviar Voto",
      vote_submitted: "Tu voto ha sido enviado",
      your_vote: "Tu voto",
      confirm_vote_title: "Confirmar tu Voto",
      result: "Resultado del Jurado",

      confirm_vote_text: "Estás votando: {vote}. Esta acción no se puede deshacer.",
      error_submitting_vote: "Ocurrió un error al enviar tu voto.",
      current_status: "Estado Actual de la Votación",
      
      // Jury Messages
      messages: "Mensajes del Jurado",
      messages_remaining: "restantes",
      chat_limited: "Hay un límite de mensajes durante la fase de jurado.",
      type_message: "Escribe tu mensaje...",
      send_message: "Enviar Mensaje",
      no_messages: "Aún no hay mensajes",
      message_limit_reached: "Has alcanzado el número máximo de mensajes permitidos.",
      error_sending_message: "Ocurrió un error al enviar el mensaje.",
      jury_member: "Miembro del Jurado",
      members: "Miembros del Jurado",
      
      // End voting early (staff)
      end_voting_early: "Finalizar Votación del Jurado",
      end_voting_early_title: "¿Finalizar Votación del Jurado?",
      end_voting_early_text: "Esto finalizará la fase de votación del jurado con los votos actuales. Esta acción será registrada. ¿Continuar?",
      mock_all_valid: "DEV: Simular jurado → Válido",
      mock_all_invalid: "DEV: Simular jurado → Inválido",
      mock_votes_title: "¿Simular votos del jurado? (DEV)",
      mock_votes_success: "Se simularon {count} voto(s) restantes del jurado.",
      mock_votes_error: "No se pudieron simular los votos del jurado.",
      voting_ended_success: "La votación del jurado ha sido finalizada. El reporte procederá a revisión del staff.",
      error_ending_voting: "Ocurrió un error al finalizar la votación del jurado.",
      resolve_type_locked: "El tipo de resolución se establece según el resultado del jurado.",
      resolve_type_locked_staff_review:
        "El tipo de resolución se rellena según el recuento de votos del jurado. Cambie solo en casos excepcionales.",
      staff_review_note:
        "El staff puede revisar y aplicar los bloques de penalización finales. Si el reporte es válido, se aplicarán penalizaciones al usuario reportado.",
      staff_review_note_invalid:
        "El staff puede revisar y cerrar el reporte. No se aplicarán penalizaciones porque el reporte se consideró inválido."
    },

    // Staff Review
    staffReview: {
      title: "Revisión del Staff",
      summary: "Resumen del Reporte",
      path: "Ruta de Resolución",
      paths: {
        accepted: "Usuario Aceptó (reducción del {reduction}%)",
        agreement: "Acuerdo Alcanzado en Conciliación",
        jury_valid: "Voto del Jurado: Válido",
        jury_invalid: "Voto del Jurado: Inválido",
        conciliation_expired: "Conciliación Expirada (Sin Acuerdo)",
        direct: "Revisión Directa del Staff"
      },
      penalties: {
        title: "Bloques de Penalización",
        original: "Sugerencia Original",
        original_desc: "Lo que solicitó el reportante",
        current: "Actual",
        current_desc_reduced: "Después de reducción del {reduction}%",
        current_desc_agreed: "Acordado en conciliación",
        current_desc_default: "De la sugerencia original",
        final: "Decisión Final",
        final_desc: "Tu selección final de penalización",
        total_severity: "Severidad Total"
      },
      resolution: {
        title: "Resolución",
        type: "Tipo de Resolución",
        types: {
          unresolved: "Sin Resolver",
          agreement: "Acuerdo",
          accept_guilt: "Aceptación de Culpa",
          valid: "Válido (Reporte Confirmado)",
          invalid: "Inválido (Reporte Rechazado)"
        },
        notes: "Notas del Staff",
        notes_placeholder: "Agrega notas sobre tu decisión (opcional pero recomendado)..."
      },
      additional_info: "Información Adicional",
      view_evidence: "Ver Evidencia",
      view_description: "Ver Descripción",
      view_conciliation: "Ver Historial de Conciliación",
      view_jury: "Ver Resultados del Jurado",
      view_audit: "Ver Registro de Auditoría",
      close_button: "Cerrar Reporte y Aplicar Penalizaciones",
      cancel: "Cancelar"
    },

    // User score related translations
    user: {
      score: "Puntuación",
      score_leaderboard: "Clasificación",
      honorable: "Usuario Honorable",
      honorable_hint: "Desbloqueado por votos correctos del jurado y reputación"
    },

    // Admin: panel de configuración de reportes (ENG-1758)
    report_settings_admin: {
      default_hours: "Por defecto: {hours} horas",
      staff_review_no_timer: "La revisión de staff no tiene temporizador: espera a que un miembro del staff cierre el reporte.",
      jury_selection_hours: "Plazo de selección de jurado",
      jury_selection_hours_help: "Tiempo para formar el jurado; después el caso pasa a revisión de staff",
      post_jury_choice_hours: "Plazo de elección post-jurado",
      post_jury_choice_hours_help: "Tiempo para que las partes acepten o escalen el resultado del jurado; después se acepta automáticamente",
      staff_voting_hours: "Plazo de votación de staff",
      staff_voting_hours_help: "Tiempo para la votación de staff; después se resuelve con los votos emitidos (el empate pasa a revisión de staff)",
      agreement_close_hours: "Cierre automático de acuerdos",
      agreement_close_hours_help: "Tiempo tras un acuerdo de conciliación antes de cerrarlo aplicando las sanciones acordadas (inmediato si no hay ninguna)",
      staff_vote_subtitle: "Votación de varios miembros del staff tras aceptar o apelar el resultado del jurado.",
      threshold_mode: "Regla de decisión",
      threshold_mode_majority: "Mayoría de votos emitidos",
      threshold_mode_percent: "Porcentaje del grupo (anterior)",
      threshold_mode_help: "Cualquier mínimo se limita al staff que comentó en los últimos 7 días",
      min_votes: "Votos mínimos",
      min_votes_help: "Votos necesarios antes de que decida la mayoría (por defecto 3)"
    },

    // Overwatch (jury) player profile + training
    notFound: {
      title: "Página no encontrada",
      message: "La página que buscas no existe o fue movida.",
      home: "Volver al inicio",
    },
    reportQueue: {
      backHome: "Volver al inicio",
      title: "Cola de reportes",
      nav: "Cola de reportes",
      age: "Antigüedad",
      status: "Estado",
      report: "Reporte",
      parties: "Reportante → acusado",
      assignee: "Asignado",
      actions: "Acciones",
      waiting: "Esperando al staff",
      answered: "Respondido",
      take: "Tomar",
      view: "Ver",
      reportAgainst: "Reporte contra {name}",
      taken: "Asignado a ti",
      filters: "Filtros",
      unassignedOnly: "Solo sin asignar",
      waitingOnly: "Solo esperando al staff",
      category: "Categoría",
      allCategories: "Todas las categorías",
      olderThan: "Más antiguos que",
      anyAge: "Cualquier antigüedad",
      days: "{n} días",
      refresh: "Actualizar",
      loading: "Cargando...",
      empty: "No hay reportes con estos filtros.",
      showing: "{shown} de {total} reportes",
      page: "Página {page} de {pages}",
      ageMinutes: "{n} min",
      ageHours: "{n} h",
      ageDays: "{n} d",
      openTicket: "Abrir reporte {id}",
    },
    overwatch: {
      title: "Overwatch",
      subtitle: "Sirve como jurado de la comunidad, gana reputación y sube de rango.",
      loading: "Cargando perfil",
      locked: "Necesitas al menos {min} de reputación (tienes {score}). Mejora para volver a participar.",
      rank_label: "Rango",
      reputation: "Reputación",
      xp_progress: "{current} / {next} XP al siguiente nivel",
      correct_votes: "Veredictos correctos",
      eligibility: "Acceso al jurado",
      level: "Nivel {level}",
      juror_n: "Jurado {n}",
      actions_label: "Acciones de Overwatch",
      meta_honorable: "Estatus",
      status_active: "Elegible",
      status_locked: "Bloqueado",
      train_cta: "Entrenar Overwatch",
      train_cta_short: "Entrenar",
      enter_jury_cta: "Buscar un caso",
      enter_jury_cta_short: "Buscar caso",
      enter_jury_locked_hint: "Completa el entrenamiento para desbloquear los casos de jurado.",
      back_home: "Volver",
      back_home_short: "Volver",
      back_profile: "Mi Overwatch",
      leaderboard: "Mejores jurados",
      leaderboard_empty: "Aún no hay ranking.",
      you: "Tú",
      my_profile: "Mi Overwatch",
      train_title: "Entrenamiento Overwatch",
      train_subtitle: "Practica el flujo completo del jurado en un caso de prueba. Nada es real.",
      train_sandbox_notice: "Modo sandbox: los votos y el chat aquí no se guardan.",
      replay_tour: "Repetir tour",
      train_status_badge: "Votación del jurado",
      train_status_text: "Caso de práctica: revisa la evidencia y emite tu voto.",
      train_deadline: "La votación cierra en 48 horas (demo)",
      train_accept: "Aceptar",
      train_dispute: "Disputar",
      train_conciliation: "Conciliación (demo)",
      train_conciliation_body: "Las partes pueden negociar sanciones antes de llamar al jurado.",
      train_chat: "Chat del caso",
      train_chat_sample: "Reportero: Por favor revisa el clip adjunto con cuidado.",
      train_chat_placeholder: "Mensaje deshabilitado en entrenamiento",
      join_locked_hint: "Reputación demasiado baja para unirte a jurados",
      locked_training: "Completa el entrenamiento Overwatch para desbloquear el jurado. Al terminarlo recibes {start} de reputación.",
      training_required_hint: "Completa el entrenamiento para unirte a jurados",
      train_complete_hint: "Termina el recorrido guiado para completar tu entrenamiento y desbloquear el jurado.",
      train_completed: "Entrenamiento completado. Jurado desbloqueado.",
      train_completed_score: "Entrenamiento completado. Ganaste {start} de reputación y ya puedes unirte a jurados.",
      train_complete_error: "No se pudo guardar tu progreso de entrenamiento. Intenta terminar el recorrido de nuevo.",
      admin_min_score_rule: "Los jugadores deben completar el entrenamiento Overwatch Y alcanzar esta puntuación. Limitado a la puntuación inicial del entrenamiento ({start}).",
      admin_min_score_clamped: "Supera la puntuación inicial del entrenamiento: el servidor usará {start}.",
      admin_training_start_score: "Puntuación inicial por entrenamiento",
      admin_training_start_score_help: "Reputación que se otorga una sola vez al completar el entrenamiento Overwatch",
      rank: {
        rookie: "Novato",
        observer: "Observador",
        juror: "Jurado",
        sentinel: "Centinela",
        arbiter: "Árbitro",
        vanguard: "Vanguardia",
        honorable: "Honorable",
        legend: "Leyenda",
      },
    },

    // Item picker (return-item penalties, etc.)
    item: {
      search_placeholder: "Buscar ítems...",
      type_to_search: "Escribe para buscar y seleccionar un ítem",
      no_results: "No se encontraron ítems",
      selected_items: "Ítems seleccionados",
    },

    // Penalty block related translations
    penalty: {
      select_blocks: "Seleccionar Bloques de Penalización",
      search_blocks: "Buscar bloques...",
      all_categories: "Todas las Categorías",
      statusActive: "Activo",
      statusInactive: "Inactivo",
      refresh: "Actualizar",
      disable: "Desactivar",
      quantity: "Cantidad",
      notes: "Notas",
      notes_placeholder: "Agregar notas (opcional)",
      selected_blocks: "Bloques Seleccionados",
      severity: "Severidad",
      select_items: "Seleccionar ítems",
      item_block_help: "Busca y selecciona los tipos de ítem y cantidades para esta penalización.",
      
      // Extended penalty translations
      items_to_return: "Ítems a Devolver",
      deactivate: "Desactivar",
      confirm_deactivate: "Desactivar Bloque de Penalización",
      confirm_deactivate_text: "¿Estás seguro de que quieres desactivar este bloque de penalización?",
      block_created: "Bloque de penalización creado",
      block_updated: "Bloque de penalización actualizado",
      block_activated: "Bloque de penalización activado",
      block_deactivated: "Bloque de penalización desactivado",
      error_saving_block: "Error al guardar el bloque",
      error_activating_block: "Error al activar el bloque",
      error_deactivating_block: "Error al desactivar el bloque",

      blocks: "Bloques de Penalización",
      block: "Bloque de Penalización",
      no_blocks: "No hay bloques de penalización disponibles",
      no_selection: "No hay penalizaciones seleccionadas",
      add_block: "Agregar Bloque",
      remove_block: "Quitar Bloque",
      suggested_blocks: "Bloques de Penalización Sugeridos",
      agreed_blocks: "Bloques de Penalización Acordados",
      final_blocks: "Bloques de Penalización Finales",
      history: "Historial de Penalizaciones",
      
      severity_levels: {
        low: "Bajo",
        medium: "Medio",
        high: "Alto",
        severe: "Severo",
        maximum: "Máximo"
      },
      
      categories: {
        warning: "Advertencia",
        ban: "Baneo",
        fine: "Multa",
        restriction: "Restricción",
        penalty: "Penalización",
        item: "Item",
        sanction: "Sanción",
        other: "Otro"
      },
      
      management: {
        title: "Gestión de Bloques de Penalización",
        create: "Crear Nuevo Bloque",
        edit: "Editar Bloque",
        deactivate: "Desactivar",
        activate: "Activar",
        code: "Código",
        code_help: "Identificador único (ej. BAN_7D)",
        name_en: "Nombre (Inglés)",
        name_es: "Nombre (Español)",
        description_en: "Descripción (Inglés)",
        description_es: "Descripción (Español)",
        category: "Categoría",
        is_active: "Activo",
        confirm_deactivate: "¿Estás seguro de que quieres desactivar este bloque?",
        category_placeholder: "ej. ban, warning, fine, Item",
        category_help: "Usa la categoría \"Item\" para habilitar la selección de ítems en este bloque",
      },

      // Trade related
      trade_proposal: "Propuesta de Intercambio",
      proposed_by: "Propuesto por",
      proposed_blocks: "Bloques Propuestos",
      active_trades: "Propuestas de Intercambio Activas",
      agreement_reached: "Acuerdo alcanzado",
      with_trade_proposal: "Con Intercambio",
      propose_trade: "Proponer Intercambio",
      propose_new_trade: "Proponer Nuevo Intercambio de Penalización",
      trade_message: "Mensaje (opcional)",
      trade_message_placeholder: "Explica tu propuesta...",
      submit_trade: "Enviar Propuesta",
      counter_trade: "Contrapropuesta",
      counter_trade_message_placeholder: "Explica tu contrapropuesta...",
      submit_counter: "Enviar Contrapropuesta",
      accept_trade: "Aceptar Intercambio",
      reject_trade: "Rechazar Intercambio",
      counter_proposal_reference: "Esta es una contrapropuesta a una propuesta anterior",
      
      trade_status: {
        pending: "Pendiente",
        accepted: "Aceptado",
        rejected: "Rechazado",
        countered: "Contrapropuesto",
        expired: "Expirado"
      },
      
      confirm_accept_trade: "Aceptar Propuesta de Intercambio",
      confirm_accept_trade_text: "¿Estás seguro de que quieres aceptar esta propuesta de intercambio? Esto creará un acuerdo.",
      confirm_reject_trade: "Rechazar Propuesta de Intercambio",
      confirm_reject_trade_text: "¿Estás seguro de que quieres rechazar esta propuesta de intercambio?",
      error_accepting_trade: "Ocurrió un error al aceptar el intercambio.",
      error_rejecting_trade: "Ocurrió un error al rechazar el intercambio.",
      error_proposing_trade: "Ocurrió un error al proponer el intercambio.",
      error_countering_trade: "Ocurrió un error al contraproponer el intercambio."
    },

    // Notifications / Toasts
    notifications: {
      report_accepted: "El reporte ha sido aceptado",
      report_disputed: "El reporte ha sido disputado",
      conciliation_started: "Fase de conciliación iniciada",
      new_message: "Nuevo mensaje recibido",
      trade_proposed: "Nueva propuesta de negociación de penalización",
      trade_accepted: "Propuesta de negociación aceptada",
      trade_rejected: "Propuesta de negociación rechazada",
      trade_countered: "Contrapropuesta recibida",
      agreement_reached: "Acuerdo alcanzado",
      conciliation_expired: "Período de conciliación expirado",
      jury_assigned: "El jurado ha sido asignado",
      jury_vote_recorded: "Tu voto ha sido registrado",
      jury_complete: "Votación del jurado completada",
      report_closed: "El reporte ha sido cerrado",
      deadline_warning: "Fecha límite de {type} en {hours} horas",
      error_generic: "Ocurrió un error. Por favor, intenta de nuevo.",
      success_generic: "Acción completada exitosamente."
    },

    // Common / Shared
    panel: {
      noAccess: {
        title: "No tienes acceso a esta sección",
        back: "Volver al panel general",
        body: "Tu cuenta no tiene los permisos necesarios para verla. Si crees que es un error, pídelo a un administrador.",
      },
      table: {
        refresh: "Actualizar",
        loading: "Cargando...",
        showing: "Mostrando {shown} de {total} {item}",
        page: "Página {page} de {pages}",
        filters: "Filtros",
        downloadCsv: "Descargar CSV",
        downloadJson: "Descargar JSON",
        empty: "Sin datos",
      },
      assistant: {
        hide: "Ocultar",
        title: "Asistente del staff",
        close: "Cerrar",
        conversations: "Conversaciones",
        newChat: "Nueva",
        placeholder: "Pide un resumen, próximos pasos, resultados...",
        copy: "Copiar",
        chat: "Chat",
        conversation: "Conversación",
        closeList: "Cerrar lista",
        viewChats: "Ver conversaciones",
        resize: "Redimensionar"
      },
      config: {
        "title": "Configuración",
        "subtitle": "Funciones y ajustes del sistema. Los cambios se aplican al sistema en vivo.",
        "refresh": "Actualizar",
        "empty": "No hay configuraciones.",
        "loading": "Cargando...",
        "searchPlaceholder": "Buscar por nombre o descripción",
        "filterLabel": "Filtrar funciones",
        "filter": {
          "all": "Todas",
          "on": "Activas",
          "off": "Inactivas",
          "changed": "Modificadas"
        },
        "flagsTitle": "Funciones",
        "groups": {
          "reports": "Reportes y Overwatch",
          "tickets": "Tickets",
          "classifier": "Clasificador",
          "ai": "IA",
          "login": "Inicio de sesión",
          "performance": "Rendimiento",
          "other": "Otros"
        },
        "statOn": "funciones activas de {total}",
        "statOff": "funciones inactivas",
        "statChanged": "distintas del valor por defecto",
        "on": "Activa",
        "off": "Inactiva",
        "changed": "Por defecto: {value}",
        "changedShort": "Modificada",
        "reset": "Restablecer",
        "jsonFlagHint": "Los demás campos de este ajuste están en Ajustes avanzados.",
        "advancedTitle": "Ajustes avanzados",
        "advancedHint": "Números, texto, prompts y JSON. Abre un elemento para editarlo.",
        "value": "Valor",
        "defaultIs": "Por defecto:",
        "empty_value": "(vacío)",
        "format": "Dar formato",
        "cancel": "Cancelar",
        "save": "Guardar",
        "invalidJson": "Esto no es un JSON válido.",
        "invalidNumber": "Introduce un número.",
        "updatedBy": "Actualizado por",
        "system": "Sistema",
        "noMatches": "Sin coincidencias.",
        "confirmTitle": "¿Cambiar {key}?",
        "confirmApply": "Aplicar",
        "whitelistWarning": "Mientras esté apagado, todo reporte espera la aprobación del staff. Al encenderlo, solo se retienen los jugadores de protected_report_targets. Revisa antes que esa lista esté lista.",
        "saved": "{key} actualizada.",
        "saveFailed": "No se pudo actualizar {key}. No se cambió nada.",
        "loadFailed": "No se pudo cargar la configuración.",
        "names": {
          "FEATURE_SIMPLE_REPORT_FLOW": "Formulario de reporte simplificado",
          "FEATURE_SIMPLE_TICKET_FLOW": "Formulario de ticket simplificado",
          "SIMPLE_TICKET_REPORT_DETECTION": "Detectar reportes en tickets",
          "FEATURE_JURY_REPORTS": "Jurado en reportes",
          "REPORT_AUTO_ASSIGN": "Asignación automática de reportes",
          "IDLE_AUTOCLOSE": "Cierre de tickets inactivos",
          "DUPLICATE_GUARD": "Control de reportes duplicados",
          "FEATURE_CATEGORY_SUGGESTIONS": "Sugerencias de categoría",
          "CLASSIFIER_SUGGEST_REROUTE": "Sugerir reubicación",
          "AI_ENABLED": "Funciones de IA",
          "FEATURE_AUTH_CODE_FLOW": "Inicio de sesión con código",
          "TICKET_LIST_PROJECTION": "Listas de tickets ligeras",
          "TICKET_PATCH_EVENTS": "Eventos de cambios en tickets",
          "FEATURE_REPORT_EVIDENCE_RULES": "Reglas de evidencia en reportes",
          "FEATURE_STAFF_ID_REDACTION": "Ocultar ids de jugadores al staff",
          "FEATURE_REPORT_QUEUE": "Cola de reportes",
          "protected_report_approval_enabled": "Aprobación de reportes protegidos",
          "protected_report_whitelist_enabled": "Aprobación solo para jugadores listados",
          "CACHE_METRICS_ENABLED": "Métricas de caché"
        },
        "descriptions": {
          "FEATURE_SIMPLE_REPORT_FLOW": "Creación de reportes en un solo formulario. El flujo anterior queda como respaldo.",
          "FEATURE_SIMPLE_TICKET_FLOW": "Creación de tickets en un solo formulario.",
          "SIMPLE_TICKET_REPORT_DETECTION": "Sugiere el flujo de reporte cuando un ticket parece un reporte.",
          "FEATURE_JURY_REPORTS": "Envía los reportes elegibles al jurado de Overwatch.",
          "REPORT_AUTO_ASSIGN": "Asigna los reportes abiertos al staff automáticamente.",
          "IDLE_AUTOCLOSE": "Cierra los tickets sin actividad pasado el tiempo configurado.",
          "DUPLICATE_GUARD": "Bloquea reportes repetidos del mismo caso.",
          "FEATURE_CATEGORY_SUGGESTIONS": "Sugiere la categoría del ticket con el clasificador.",
          "CLASSIFIER_SUGGEST_REROUTE": "Sugiere mover un ticket a otra categoría.",
          "AI_ENABLED": "Interruptor general de la IA. Requiere la clave de Gemini.",
          "FEATURE_AUTH_CODE_FLOW": "Usa el flujo de código de autorización para iniciar sesión.",
          "TICKET_LIST_PROJECTION": "Devuelve solo los campos que necesitan las listas.",
          "TICKET_PATCH_EVENTS": "Envía los cambios de tickets por socket como parches pequeños.",
          "FEATURE_REPORT_EVIDENCE_RULES": "Aplica los límites y requisitos de evidencia al crear reportes. Apagado equivale a prod.",
          "FEATURE_STAFF_ID_REDACTION": "Oculta los ids de cuenta a los miembros del staff sin permisos de admin.",
          "FEATURE_REPORT_QUEUE": "Muestra la cola de reportes al staff.",
          "protected_report_approval_enabled": "Interruptor general: los reportes contra jugadores protegidos esperan aprobación del staff.",
          "protected_report_whitelist_enabled": "Retiene solo los reportes contra los jugadores de protected_report_targets. Apagado retiene todos.",
          "CACHE_METRICS_ENABLED": "Registra aciertos y fallos de caché."
        }
      },
      dashboard: {
        generalInfo: "Información general",
        leaderboards: "Clasificaciones de usuarios",
        mostTickets: "Más tickets enviados",
        mostActive: "Más activo",
        noDataYet: "Sin datos todavía"
      },
      incidents: {
        status: {
          open: "Abierto",
          investigating: "En investigación",
          resolved: "Resuelto",
          closed: "Cerrado"
        },
        statusLabel: "Estado:",
        description: "Descripción",
        author: "Autor",
        message: "Mensaje",
        dateTime: "Fecha y hora:",
        addEntry: "Agregar entrada",
        cancel: "Cancelar",
        update: "Actualizar",
        log: {
          title: "Registro de incidentes",
          newIncident: "Nuevo incidente",
          empty: "No se encontraron incidentes.",
          createTitle: "Crear incidente",
          titlePlaceholder: "Título",
          create: "Crear",
          timeline: "Cronología"
        },
        detail: {
          back: "Volver a la lista",
          downloadMarkdown: "Descargar en Markdown",
          downloadPostmortem: "Descargar postmortem",
          generating: "Generando...",
          created: "Creado: {date}",
          entries: "Entradas",
          edit: "Editar",
          delete: "Eliminar",
          save: "Guardar",
          confirmDelete: "¿Seguro que quieres eliminar esta entrada?"
        },
        errors: {
          updateStatus: "No se pudo actualizar el estado. Inténtalo de nuevo.",
          downloadMarkdown: "No se pudo descargar el Markdown. Inténtalo de nuevo.",
          postmortem: "No se pudo generar el postmortem. Inténtalo de nuevo.",
          updateEntry: "No se pudo actualizar la entrada.",
          deleteEntry: "No se pudo eliminar la entrada."
        }
      },
      penaltyBlocks: {
        codePlaceholder: "p. ej. BAN_7D",
        errorTitle: "Error",
        successTitle: "Listo",
        loadFailed: "No se pudieron cargar los bloques de sanción",
        codeRequired: "El código es obligatorio",
        codeTooLong: "El código no puede tener más de 20 caracteres",
        nameEnRequired: "El nombre en inglés es obligatorio",
        severityRange: "La gravedad debe estar entre 1 y 10",
        created: "Bloque de sanción creado correctamente",
        updated: "Bloque de sanción actualizado correctamente",
        deactivated: "Bloque de sanción desactivado correctamente",
        activated: "Bloque de sanción activado correctamente",
        saveFailed: "No se pudo guardar el bloque de sanción",
        deactivateFailed: "No se pudo desactivar el bloque de sanción",
        activateFailed: "No se pudo activar el bloque de sanción"
      },
      classifier: {
        title: "Clasificador",
        window: "Ventana",
        since: "Flag activo desde",
        days: "Últimos {n} días",
        loadFailed: "No se pudieron cargar los datos del clasificador.",
        model: "Modelo activo",
        noModel: "Sin modelo activo",
        trainedAt: "Entrenado el",
        accuracy: "Precisión top-1 / top-3",
        labels: "Etiquetas",
        threshold: "Umbral",
        effectiveThreshold: "efectivo",
        flags: "Flags",
        flag: { simpleTicketFlow: "Ticket simple", simpleReportFlow: "Reporte simple", categorySuggestions: "Sugerencias" },
        on: "activo",
        off: "inactivo",
        truncated: "Un periodo supera el límite de muestra; las cifras usan los tickets más recientes.",
        impactTitle: "Antes y después",
        impactHelp: "Después: los últimos {days} días. Antes: los {days} días anteriores. Vigila que baje el porcentaje de Otros, que los cambios del jugador queden bajo el 20% y que la primera respuesta no empeore.",
        dailyTitle: "Por día (UTC)",
        noTickets: "No hay tickets en esta ventana.",
        day: "Día",
        type: "Tipo",
        period: "Periodo",
        types: { support: "Soporte", report: "Reporte" },
        periods: { before: "Antes", after: "Después" },
        col: {
          total: "Tickets",
          catchAllShare: "Otros",
          withDecision: "Con decisión",
          bySource: "Auto / respaldo / jugador / ninguna",
          overrideRate: "Cambios",
          autoShare: "% auto",
          medianFirstResponse: "1ª respuesta (mediana)",
          p90FirstResponse: "1ª respuesta (p90)",
          medianClose: "Cierre (mediana)"
        }
      },
      reportSettings: {
        title: "Configuración del sistema de reportes",
        subtitle: "Configura los plazos, los puntajes de usuario, el jurado y otros parámetros del sistema de reportes.",
        deadlines: {
          title: "Plazos del reporte",
          subtitle: "Configura los límites de tiempo de cada fase del proceso de reporte.",
          response: "Plazo de respuesta",
          conciliation: "Plazo de conciliación",
          juryVoting: "Plazo de votación del jurado",
          responseHelp: "Tiempo para que el usuario reportado responda (aceptar o disputar)",
          conciliationHelp: "Tiempo para las negociaciones de la fase de conciliación",
          juryVotingHelp: "Tiempo para que los jurados emitan sus votos"
        },
        common: {
          hours: "horas",
          pts: "pts",
          days: "días",
          resetDefaults: "Restablecer valores",
          save: "Guardar",
          defaultHours: "Predeterminado: {n} horas",
          yes: "Sí",
          no: "No",
          enabled: "Activado",
          disabled: "Desactivado",
          required: "Obligatoria",
          optional: "Opcional",
          error: "Error",
          success: "Listo",
          info: "Información"
        },
        scores: {
          title: "Valores de puntaje de usuario",
          subtitle: "Configura los puntos para cada resultado de un reporte.",
          outcomesTitle: "Resultados del reporte",
          acceptanceTitle: "Aceptación y participación en el jurado",
          severityTitle: "Descuento por gravedad",
          validReporter: "Válido - Reportante",
          validReported: "Válido - Reportado",
          invalidReporter: "Inválido - Reportante",
          invalidReported: "Inválido - Reportado",
          validReporterHelp: "El reportante gana (reporte válido)",
          validReportedHelp: "El reportado pierde (reporte válido)",
          invalidReporterHelp: "El reportante pierde (reporte inválido)",
          invalidReportedHelp: "El reportado gana (reporte inválido)",
          acceptReported: "Aceptar - Reportado",
          acceptReportedHelp: "Penalización base por aceptar",
          juryParticipation: "Participación en el jurado",
          juryParticipationHelp: "Puntos por votar",
          juryCorrectVote: "Voto correcto del jurado",
          juryCorrectVoteHelp: "Bono por voto correcto",
          juryIncorrectVote: "Voto incorrecto del jurado",
          juryIncorrectVoteHelp: "Penalización por voto incorrecto",
          perSeverityPoint: "Por punto de gravedad",
          perSeverityPointHelp: "Descuento por cada punto de gravedad"
        },
        jury: {
          title: "Configuración del jurado",
          subtitle: "Configura los parámetros del sistema de jurado y los requisitos de elegibilidad.",
          compositionTitle: "Composición del jurado",
          eligibilityTitle: "Requisitos de elegibilidad",
          size: "Tamaño del jurado",
          sizeHelp: "Miembros por caso (3-15)",
          maxCount: "Máximo de jurados",
          maxCountHelp: "Máximo de miembros permitidos (incluidos los asignados automáticamente)",
          minVotes: "Mínimo de votos requeridos",
          minVotesHelp: "Votos mínimos para decidir",
          majorityType: "Tipo de mayoría",
          majorityTypeHelp: "Umbral de votación",
          majoritySimple: "Simple (50% + 1)",
          majoritySuper: "Súper (2/3)",
          minScore: "Puntaje mínimo de usuario",
          minAccountAge: "Antigüedad mínima de la cuenta",
          minAccountAgeHelp: "Antigüedad mínima de la cuenta",
          maxActiveDuties: "Máximo de deberes activos",
          maxActiveDutiesHelp: "Máximo de asignaciones simultáneas",
          excludeStaff: "Excluir al staff",
          excludeStaffHelp: "El staff no puede ser jurado",
          excludeSameFaction: "Excluir la misma facción",
          excludeSameFactionHelp: "Bloquea a los miembros de la facción de las partes",
          excludeKnownUsers: "Excluir usuarios conocidos",
          excludeKnownUsersHelp: "Bloquea las cuentas conocidas en común",
          rotation: "Rotación del jurado",
          rotationHelp: "Excluye a jurados recientes (0 = desactivado)",
          honorableMinScore: "Puntaje mínimo para Honorable",
          honorableMinScoreHelp: "Puntaje necesario para ser Usuario Honorable",
          honorableMinVotes: "Mínimo de votos correctos para Honorable",
          honorableMinVotesHelp: "Votos correctos necesarios (las recompensas se configuran en el gamemode)"
        },
        staffReview: {
          title: "Votación de revisión del staff",
          voteMode: "Modo de votación",
          modeAny: "Cualquier staff del grupo",
          modeAutoAssign: "Asignar staff al azar",
          voteModeHelp: "Quién puede emitir votos del staff",
          autoAssignCount: "Cantidad de asignación automática",
          autoAssignCountHelp: "Se usa cuando el modo es asignación automática",
          threshold: "Umbral %",
          thresholdHelp: "Votos necesarios para aceptar o rechazar",
          poolSize: "Tamaño del grupo (modo cualquiera)",
          poolSizeHelp: "Denominador cuando el modo es cualquiera"
        },
        reduction: {
          title: "Reducción de penalización",
          subtitle: "Configura los incentivos de reducción por aceptar reportes.",
          percent: "Porcentaje de reducción",
          percentHelp: "% de reducción al aceptar",
          appliesTo: "Se aplica a",
          severity: "Gravedad",
          quantity: "Cantidad",
          both: "Ambas",
          appliesToHelp: "Qué se reduce",
          minSeverity: "Gravedad mínima después",
          minSeverityHelp: "Mínimo después de la reducción"
        },
        general: {
          title: "Configuración general",
          subtitle: "Configura los parámetros generales del sistema de reportes.",
          maxBlocks: "Máximo de bloques de penalización",
          maxBlocksHelp: "Máximo de bloques por reporte",
          maxEvidence: "Máximo de evidencias",
          maxEvidenceHelp: "Máximo de evidencias por reporte",
          maxJuryMessages: "Máximo de mensajes en la fase de jurado",
          maxJuryMessagesHelp: "Máximo de mensajes por usuario en la fase de jurado",
          allowAnonymous: "Permitir reportes anónimos",
          allowAnonymousHelp: "Reportes anónimos",
          requireEvidence: "Exigir evidencia",
          requireEvidenceHelp: "Requisito de evidencia"
        },
        tabs: {
          deadlines: "Plazos",
          scores: "Puntajes de usuario",
          jury: "Jurado",
          staffReview: "Revisión del staff",
          reduction: "Reducción de penalización",
          general: "General"
        },
        messages: {
          loadFailed: "No se pudo cargar la configuración",
          saved: "{section}: guardado correctamente",
          saveFailed: "No se pudo guardar la configuración",
          reset: "{section}: valores restablecidos. Haz clic en Guardar para aplicar."
        },
        sections: {
          deadlines: "Plazos",
          scores: "Puntajes de usuario",
          jury: "Configuración del jurado",
          staffReview: "Revisión del staff",
          reduction: "Reducción de penalización",
          general: "Configuración general"
        }
      },
      sidebar: {
        title: "Panel de soporte",
        items: {
          dashboard: "Panel general",
          staff: "Staff",
          tickets: "Tickets",
          users: "Usuarios",
          tokens: "Tokens",
          config: "Configuración",
          "penalty-blocks": "Bloqueos por sanción",
          "report-settings": "Ajustes de reportes",
          classifier: "Clasificador",
          incidents: "Incidentes"
        }
      },
      staff: {
        title: "Rendimiento del staff",
        itemName: "registros de staff",
        filters: {
          staffMember: "Miembro del staff",
          status: "Estado",
          ticketType: "Tipo de ticket",
          dateFrom: "Desde",
          dateTo: "Hasta",
          sortBy: "Ordenar por",
          itemsPerPage: "Elementos por página",
          apply: "Aplicar filtros"
        },
        columns: {
          staff: "Staff",
          date: "Fecha",
          reports: "Reportes",
          support: "Tickets de soporte",
          total: "Total de tickets"
        },
        options: {
          allStaff: "Todo el staff",
          all: "Todos",
          opened: "Abiertos",
          closed: "Cerrados",
          allTypes: "Todos los tipos",
          reportsOnly: "Solo reportes",
          supportOnly: "Solo soporte"
        },
        sort: {
          date: "Fecha",
          staff: "Nombre del staff",
          reports: "Cantidad de reportes",
          support: "Cantidad de soporte",
          total: "Total de tickets"
        },
        errors: {
          downloadCsv: "No se pudo descargar el CSV. Inténtalo de nuevo.",
          downloadJson: "No se pudo descargar el JSON. Inténtalo de nuevo."
        }
      },
      tickets: {
        title: "Gestión de tickets",
        downloadCsv: "Descargar CSV",
        downloadJson: "Descargar JSON",
        refresh: "Actualizar",
        filters: "Filtros",
        ticketType: "Tipo de ticket",
        search: "Buscar",
        group: "Grupo",
        sortBy: "Ordenar por",
        createdFrom: "Creado desde",
        createdTo: "Creado hasta",
        source: "Origen",
        itemsPerPage: "Elementos por página",
        status: "Estado",
        support: "Soporte",
        reports: "Reportes",
        open: "Abiertos",
        closed: "Cerrados",
        mine: "Míos",
        unassigned: "Sin asignar",
        juryDuty: "Servicio de jurado",
        newest: "Más recientes primero",
        oldest: "Más antiguos primero",
        latestComment: "Último comentario",
        oldestComment: "Comentario más antiguo",
        inGame: "En el juego",
        web: "Web",
        searchPlaceholder: "Buscar tickets...",
        allGroups: "Todos los grupos",
        applyFilters: "Aplicar filtros",
        showing: "Mostrando {shown} de {total} tickets",
        page: "Página {page} de {pages}",
        colTitle: "Título",
        colType: "Tipo",
        colCategory: "Categoría",
        colCreatedBy: "Creado por",
        colAssignedTo: "Asignado a",
        colComments: "Comentarios",
        colCreated: "Creado",
        colLastComment: "Último comentario",
        typeReport: "Reporte",
        loading: "Cargando tickets...",
        csvFailed: "No se pudo descargar el CSV. Inténtalo de nuevo.",
        jsonFailed: "No se pudo descargar el JSON. Inténtalo de nuevo."
      },
      tokens: {
        title: "Tokens de acceso",
        createNew: "Crear token",
        active: "Tokens activos",
        total: "Total de tokens",
        expired: "Tokens vencidos",
        inactive: "Tokens inactivos",
        tableTitle: "Tokens de acceso",
        colName: "Nombre",
        colEndpoints: "Endpoints",
        colPermissions: "Permisos",
        colCreatedBy: "Creado por",
        colCreated: "Creado",
        colExpires: "Vence",
        colStatus: "Estado",
        colActions: "Acciones",
        more: "+{n} más",
        read: "Lectura",
        write: "Escritura",
        admin: "Admin",
        createTitle: "Crear token de acceso",
        tokenName: "Nombre del token",
        description: "Descripción (opcional)",
        namePlaceholder: "Ej.: token de integración con la API",
        descriptionPlaceholder: "¿Para qué sirve este token?",
        endpointsCount: "Endpoints ({n})",
        loadingEndpoints: "Cargando endpoints...",
        permRead: "Lectura (solicitudes GET)",
        permWrite: "Escritura (solicitudes POST/PUT)",
        permAdmin: "Administración (solicitudes DELETE)",
        cancel: "Cancelar",
        create: "Crear token",
        selectEndpoint: "Selecciona al menos un endpoint.",
        selectPermission: "Selecciona al menos un permiso.",
        createFailed: "No se pudo crear el token. Inténtalo de nuevo.",
        copied: "Token JWT copiado al portapapeles.",
        copyFailed: "No se pudo copiar el token. Cópialo manualmente.",
        confirmDeactivate: "¿Seguro que quieres desactivar este token?",
        deactivateFailed: "No se pudo desactivar el token.",
        activateFailed: "No se pudo activar el token.",
        confirmDelete: "¿Seguro que quieres eliminar este token? No se puede deshacer.",
        deleteFailed: "No se pudo eliminar el token.",
        titleExpired: "Token vencido",
        titleInactive: "Token inactivo",
        titleCopy: "Copiar token",
        statusExpired: "Vencido",
        statusInactive: "Inactivo",
        statusActive: "Activo",
        created: "Token creado correctamente.\n\nToken JWT: {jwt}\n\nID del token: {id}"
      }
    },
    common: {
      yesterday: "Ayer",
      daysAgo: "días atrás",
      loading: "Cargando...",
      saving: "Guardando...",
      save: "Guardar",
      cancel: "Cancelar",
      confirm: "Confirmar",
      delete: "Eliminar",
      edit: "Editar",
      create: "Crear",
      close: "Cerrar",
      back: "Volver",
      next: "Siguiente",
      submit: "Enviar",
      search: "Buscar",
      filter: "Filtrar",
      all: "Todos",
      none: "Ninguno",
      yes: "Sí",
      no: "No",
      or: "o",
      and: "y",
      items: "elementos",
      selected: "seleccionado(s)",
      required: "Requerido",
      optional: "Opcional",
      error: "Error",
      success: "Éxito",
      warning: "Advertencia",
      info: "Información",
      unknown: "Desconocido"
    },

    // Time / Deadlines
    time: {
      hours: "horas",
      hour: "hora",
      minutes: "minutos",
      minute: "minuto",
      seconds: "segundos",
      second: "segundo",
      days: "días",
      day: "día",
      remaining: "restante(s)",
      expired: "Expirado",
      deadline: "Fecha Límite",
      deadline_response: "Fecha Límite de Respuesta",
      deadline_conciliation: "Fecha Límite de Conciliación",
      deadline_jury: "Fecha Límite de Votación"
    },

    actions: "Acciones",
    send: "Enviar",
    takenBy: "Tomado por",

    titleComplete: "Titulo a mostrar: ",
    location_selected: "Seleccionado",
    error_title: "Coloca un título para seleccionar fecha",
    showMapButton: "Ver en mapa",
    copyMapId: "Copiar ID del mapa",
    enableMapInstance: "Habilitar instancia del mapa",
    enableMapInstanceConfirm: "Habilitar instancia del mapa",
    enableMapInstanceSuccess: "Instancia del mapa habilitada correctamente.",
    enableMapInstanceError: "No se pudo habilitar la instancia del mapa.",
    disableMapInstance: "Deshabilitar instancia del mapa",
    disableMapInstanceConfirm: "Deshabilitar instancia del mapa",
    disableMapInstanceSuccess: "Instancia del mapa deshabilitada correctamente.",
    disableMapInstanceError: "No se pudo deshabilitar la instancia del mapa.",
    events: {
      select: ["External software", "YouTube links", "No"],
    },
    create_event_error_title: " ¿Problemas técnicos creando tu evento?",
    create_event_error_info: "Describe el problema técnico que ocurrió agendando tu evento.",
    create_event_error_info_more: "Este campo sólo se debe usar en caso de un problema técnico.",
    create_event_error_button: "Enviar",
    load_more: "Cargar más",
    fetchMoreComments: "Cargar más comentarios",
    scrollToBottom: "Ir al final",
    suggestedResponses: "Respuestas sugeridas",
    useResponse: "Usar respuesta",
    editResponse: "Editar respuesta",
    save: "Guardar",
    createdBy: "Creado por",
  }
}
